var Ct = Object.defineProperty;
var Rt = (n, a, t) => a in n ? Ct(n, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[a] = t;
var K = (n, a, t) => Rt(n, typeof a != "symbol" ? a + "" : a, t);
import { z as e } from "zod";
class $ extends Error {
  constructor(t, r, i, o) {
    super(t);
    K(this, "status");
    K(this, "code");
    K(this, "body");
    this.name = "ApiError", this.status = r, this.code = o, this.body = i;
  }
  /** True для 401 (требуется re-login). */
  get isUnauthorized() {
    return this.status === 401;
  }
  /** True для 403 (отсутствует permission). */
  get isForbidden() {
    return this.status === 403;
  }
  /** True для 404. */
  get isNotFound() {
    return this.status === 404;
  }
  /** True для 5xx — должен ретрайаться UI'ом. */
  get isServerError() {
    return this.status >= 500;
  }
}
function jt(n, a, t) {
  const r = a.startsWith("http://") || a.startsWith("https://"), i = n.startsWith("http://") || n.startsWith("https://"), o = typeof window < "u" && window.location ? window.location.origin : "http://localhost", s = r ? new URL(a) : i ? new URL(`${n}${a}`) : new URL(`${n}${a}`, o);
  if (t) {
    for (const [l, c] of Object.entries(t))
      if (c != null)
        if (Array.isArray(c))
          for (const d of c)
            d != null && s.searchParams.append(l, String(d));
        else
          s.searchParams.set(l, String(c));
  }
  return s.toString();
}
function Kr(n) {
  const { baseUrl: a } = n;
  if (!(a.startsWith("http://") || a.startsWith("https://") || a.startsWith("/")))
    throw new Error(
      `Некорректный baseUrl ApiClient'а: "${a}". Ожидается абсолютный URL (http(s)://...) либо относительный путь от origin'а (/api).`
    );
  const r = n.fetch ?? globalThis.fetch.bind(globalThis);
  async function i(o, s = {}) {
    const { method: l = "GET", token: c, body: d, query: C, headers: M, ...W } = s, Y = jt(n.baseUrl, o, C), p = {
      Accept: "application/json",
      ...n.defaultHeaders,
      ...M
    };
    c && (p.Authorization = `Bearer ${c}`), d !== void 0 && !(d instanceof FormData) && (p["Content-Type"] = p["Content-Type"] ?? "application/json");
    const v = await r(Y, {
      ...W,
      method: l,
      headers: p,
      body: d === void 0 ? void 0 : d instanceof FormData ? d : JSON.stringify(d)
    });
    if (v.status === 204) return;
    const ke = v.headers.get("content-type") ?? "", le = ke.includes("application/json") || ke.includes("+json"), h = le ? await v.json().catch(() => null) : await v.text();
    if (!v.ok) {
      const At = le && h && typeof h == "object" && "code" in h ? String(h.code) : void 0, Ot = le && h && typeof h == "object" && "message" in h ? String(h.message) : `HTTP ${v.status}`;
      throw new $(Ot, v.status, h, At);
    }
    return h;
  }
  return {
    request: i,
    config: n
  };
}
const Ge = e.enum(["light", "dark", "auto"]), Be = e.object({
  userId: e.string(),
  username: e.string(),
  email: e.string().email().optional().nullable(),
  displayName: e.string().optional().nullable(),
  distributorId: e.number().int().nullable().optional(),
  /** Subdomain slug текущего тенанта (например, "darkside"). Используется
   *  для построения URL обмена с 1С: `https://<slug>.ds2b.ru/seller/exchange-1c`.
   *  null для PLATFORM_ADMIN. (S21 / D14-Arch-3) */
  distributorSubdomainSlug: e.string().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  isPlatformAdmin: e.boolean(),
  permissions: e.array(e.string()),
  roles: e.array(e.string()),
  themePreference: Ge.default("auto"),
  /** Для CLIENT_EMPLOYEE — id точек, на которые он назначен. (D01 §1.4) */
  assignedTradepointIds: e.array(e.number().int()).optional().nullable()
}), qt = e.object({
  themePreference: Ge.optional(),
  displayName: e.string().min(1).max(120).optional()
}).strict(), Ve = e.object({
  userId: e.string(),
  username: e.string(),
  email: e.string().nullable().optional(),
  emailVerified: e.boolean(),
  displayName: e.string().nullable().optional(),
  firstName: e.string().nullable().optional(),
  lastName: e.string().nullable().optional(),
  phone: e.string().nullable().optional(),
  role: e.string().nullable().optional(),
  isPlatformAdmin: e.boolean(),
  distributorId: e.number().int().nullable().optional(),
  distributorDisplayName: e.string().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  clientName: e.string().nullable().optional(),
  /** ISO-8601 Instant; null если KC не отдаёт createdTimestamp. */
  createdAt: e.string().nullable().optional(),
  /** Резерв; в KC 25 недоступен через UserRepresentation. */
  lastLoginAt: e.string().nullable().optional()
}), Dt = e.object({
  displayName: e.string().min(1).max(120).optional(),
  phone: e.string().max(64).regex(/^$|^[+()\-\s\d]{0,64}$/, "Допустимы цифры, пробел и символы + ( ) -").optional()
}).strict(), $t = e.object({
  currentPassword: e.string().min(1, "Введите текущий пароль"),
  newEmail: e.string().min(1, "Введите новый email").email("Некорректный формат email").max(255)
}).strict(), xt = e.object({
  currentPassword: e.string().min(1, "Введите текущий пароль"),
  newPassword: e.string().min(12, "Новый пароль должен быть не менее 12 символов")
}).strict(), u = (n) => e.object({
  content: e.array(n),
  totalElements: e.number().int().nonnegative(),
  totalPages: e.number().int().nonnegative(),
  number: e.number().int().nonnegative(),
  size: e.number().int().positive()
}), Z = e.enum([
  "DISTRIBUTOR_OWNER",
  "DISTRIBUTOR_ADMIN",
  "DISTRIBUTOR_MANAGER",
  "DISTRIBUTOR_FIELD_EMPLOYEE",
  "CLIENT_OWNER",
  "CLIENT_EMPLOYEE"
]), Qr = Z, He = e.enum([
  "PENDING",
  "ACCEPTED",
  "EXPIRED",
  "REVOKED"
]), Xr = He, Nt = e.object({
  id: e.string(),
  kind: Z,
  distributorId: e.number().int().nullable(),
  clientId: e.number().int().nullable(),
  tradepointIds: e.array(e.number().int()).nullable().optional(),
  email: e.string().email(),
  suggestedFullName: e.string().nullable().optional(),
  suggestedUsername: e.string().nullable().optional(),
  state: He,
  createdByUserId: e.string(),
  createdAt: e.string(),
  expiresAt: e.string(),
  acceptedAt: e.string().nullable().optional()
}), kt = e.object({
  tradepointId: e.number().int().positive(),
  warehouseId: e.number().int().positive()
}), Ut = e.object({
  kind: Z,
  email: e.string().email(),
  distributorId: e.number().int().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  tradepointIds: e.array(e.number().int().positive()).nullable().optional(),
  suggestedFullName: e.string().max(255).nullable().optional(),
  suggestedUsername: e.string().max(255).nullable().optional(),
  /** TT-warehouse №2: применяется на accept'е, иначе backend бросит 400 для
   *  не-CLIENT_OWNER kind. Пусто/null — TT останутся без привязки. */
  tradepointWarehouseAssignments: e.array(kt).nullable().optional()
}).strict(), Lt = e.object({
  id: e.string(),
  token: e.string(),
  expiresAt: e.string(),
  inviteUrl: e.string().url()
}), Mt = e.object({
  kind: Z,
  email: e.string().email(),
  suggestedFullName: e.string().nullable().optional(),
  suggestedUsername: e.string().nullable().optional(),
  expiresAt: e.string()
}), _t = e.object({
  /** Пароль пользователя; минимум 8 символов, финальная policy у Keycloak. */
  password: e.string().min(8).max(255),
  /** Имя пользователя для отображения; pre-fill из suggestedFullName если есть. */
  displayName: e.string().min(1).max(255),
  /** Согласие с условиями обслуживания. */
  acceptTerms: e.literal(!0)
}).strict(), zt = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  active: e.boolean(),
  primaryWarehouseId: e.number().int().nullable().optional(),
  primaryWarehouseName: e.string().nullable().optional()
}), Gt = e.object({
  /** {@code null} — отвязать склад (TT перейдёт в режим «всё под заказ»). */
  warehouseId: e.number().int().positive().nullable()
}), Bt = e.object({
  id: e.number().int(),
  externalId: e.string().uuid().nullable().optional(),
  name: e.string(),
  address: e.string().nullable().optional(),
  active: e.boolean()
}), Vt = e.enum(["HEALTHY", "DEGRADED", "DOWN"]), Ht = e.object({
  status: Vt,
  /** Последняя успешная синхронизация любого типа. */
  lastSyncAt: e.string().nullable().optional(),
  /** Последняя успешная Basic-auth 1С (exchange_credentials.last_used_at).
   *  Если новее lastSyncAt — 1С стучится, но цикл fail'ится после checkauth. */
  lastConnectionAttemptAt: e.string().nullable().optional(),
  /** Per-direction last successful sync. */
  lastCatalogSyncAt: e.string().nullable().optional(),
  lastOrdersInboundSyncAt: e.string().nullable().optional(),
  lastOrdersOutboundSyncAt: e.string().nullable().optional(),
  /** Per-direction stale: lastXxxSyncAt != null И старше per-direction threshold.
   *  Бэк делает сравнение, чтобы фронт не дублировал логику.
   *  null/undefined — направление не активировано (это не stale). */
  catalogStale: e.boolean().optional(),
  ordersInboundStale: e.boolean().optional(),
  ordersOutboundStale: e.boolean().optional(),
  /** Минут с последнего успешного синка — null если никогда не синкался. */
  staleMinutes: e.number().int().nonnegative().nullable().optional(),
  /** Общий threshold (минут), после которого статус → DEGRADED (default 24 ч). */
  degradedThresholdMinutes: e.number().int().positive().optional()
}), Ft = e.object({
  id: e.number().int(),
  distributorId: e.number().int(),
  login: e.string(),
  enabled: e.boolean(),
  /** ISO-8601 UTC. */
  createdAt: e.string(),
  /** ISO-8601 UTC; null — credentials никогда не использовались. */
  lastUsedAt: e.string().nullable().optional()
}), Wt = e.array(Ft), Fe = e.object({
  id: e.number().int(),
  login: e.string(),
  password: e.string(),
  note: e.string().optional().nullable()
}), We = e.enum([
  "success",
  "failure",
  "progress",
  "in_flight",
  "aborted"
]), Yt = e.object({
  id: e.number().int(),
  requestId: e.string(),
  /** ISO-8601 UTC. */
  startedAt: e.string(),
  finishedAt: e.string().nullable().optional(),
  durationMs: e.number().int().nullable().optional(),
  httpMethod: e.string(),
  mode: e.string().nullable().optional(),
  type: e.string().nullable().optional(),
  httpStatus: e.number().int(),
  responseStatus: We,
  bytesIn: e.number().int().nonnegative(),
  bytesOut: e.number().int().nonnegative(),
  errorCode: e.string().nullable().optional(),
  errorCategory: e.string().nullable().optional(),
  stagingFileId: e.string().uuid().nullable().optional(),
  /** PA-11 / D17 §2.6: cross-tenant обогащение для PLATFORM_ADMIN.
   *  Distributor-scoped пользователи получают null (контекст уже из JWT).
   *  Контракт симметричен OrderListItem. */
  distributorId: e.number().int().nullable().optional(),
  distributorSlug: e.string().nullable().optional(),
  distributorDisplayName: e.string().nullable().optional()
}), Kt = e.object({
  id: e.number().int(),
  distributorId: e.number().int().nullable().optional(),
  requestId: e.string(),
  startedAt: e.string(),
  finishedAt: e.string().nullable().optional(),
  durationMs: e.number().int().nullable().optional(),
  endpointPath: e.string(),
  httpMethod: e.string(),
  mode: e.string().nullable().optional(),
  type: e.string().nullable().optional(),
  queryParams: e.record(e.string()).nullable().optional(),
  httpStatus: e.number().int(),
  responseStatus: We,
  bytesIn: e.number().int().nonnegative(),
  bytesOut: e.number().int().nonnegative(),
  requestSha256: e.string().nullable().optional(),
  responseSha256: e.string().nullable().optional(),
  stagingSessionId: e.string().uuid().nullable().optional(),
  stagingFileId: e.string().uuid().nullable().optional(),
  errorCode: e.string().nullable().optional(),
  errorCategory: e.string().nullable().optional(),
  errorMessage: e.string().nullable().optional(),
  metadata: e.record(e.unknown()).nullable().optional()
}), Qt = e.object({
  subdomainSlug: e.string(),
  displayName: e.string().nullable().optional(),
  primaryColor: e.string().nullable().optional(),
  hasLogo: e.boolean()
}), Xt = e.string().regex(/^$|^#[0-9a-fA-F]{6}$/, "Цвет должен быть в формате #RRGGBB"), B = e.object({
  version: e.number().int().nonnegative().safe(),
  subdomainSlug: e.string(),
  displayName: e.string().nullable().optional(),
  generalPhone: e.string().nullable().optional(),
  generalEmail: e.string().nullable().optional(),
  generalOfficeAddress: e.string().nullable().optional(),
  primaryColor: e.string().nullable().optional(),
  defaultPriceTypeExternal: e.string().uuid().nullable().optional(),
  hasLogo: e.boolean(),
  logoStorageKey: e.string().nullable().optional()
}), Jt = e.object({
  expectedVersion: e.number().int().nonnegative().safe(),
  displayName: e.string().max(255).optional(),
  generalPhone: e.string().max(64).optional(),
  generalEmail: e.union([e.string().email(), e.literal("")]).optional(),
  generalOfficeAddress: e.string().max(1024).optional(),
  primaryColor: Xt.optional(),
  defaultPriceTypeExternal: e.string().uuid().optional(),
  clearDefaultPriceType: e.boolean().optional()
}).strict().refine((n) => !(n.clearDefaultPriceType && n.defaultPriceTypeExternal), {
  message: "Нельзя одновременно выбрать и очистить резервный вид цены",
  path: ["defaultPriceTypeExternal"]
}), Zt = e.object({
  externalId: e.string().uuid().nullable(),
  name: e.string(),
  currency: e.string().nullable().optional(),
  isDefault: e.boolean()
}), en = (n) => e.object({
  content: e.array(n),
  number: e.number().int().nonnegative(),
  size: e.number().int().positive(),
  first: e.boolean(),
  last: e.boolean(),
  numberOfElements: e.number().int().nonnegative(),
  hasNext: e.boolean().optional()
}), tn = e.object({
  id: e.number().int(),
  name: e.string(),
  description: e.string().nullable().optional(),
  tradepointCount: e.number().int().nonnegative(),
  assignedUsersCount: e.number().int().nonnegative()
}), nn = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  clientId: e.number().int(),
  active: e.boolean()
}), an = e.object({
  keycloakSub: e.string(),
  role: e.string(),
  active: e.boolean()
}), ee = e.object({
  id: e.number().int(),
  name: e.string(),
  description: e.string().nullable().optional(),
  tradepoints: e.array(nn),
  assignedUsers: e.array(an)
}), rn = e.object({
  name: e.string().min(1, "Название обязательно").max(255),
  description: e.string().max(2e3).nullable().optional(),
  tradepointIds: e.array(e.number().int()).optional()
}).strict(), on = e.object({
  name: e.string().min(1, "Название обязательно").max(255),
  description: e.string().max(2e3).nullable().optional()
}).strict(), sn = e.object({
  tradepointIds: e.array(e.number().int()).min(1)
}).strict(), ln = e.object({
  id: e.number().int(),
  name: e.string()
}), cn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  pending: e.boolean(),
  active: e.boolean()
}), un = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional()
}), Ye = e.object({
  lastTradepointId: e.number().int().nullable().optional(),
  availableTradepoints: e.array(un)
}), dn = e.object({
  tradepointId: e.number().int().positive()
}).strict(), mn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  documentNumber: e.string().nullable().optional(),
  /** ISO-8601 OffsetDateTime; может быть null до синка из 1С. */
  documentDate: e.string().nullable().optional(),
  /** ISO-8601 Instant — момент создания записи в портале. */
  createdAt: e.string(),
  clientId: e.number().int().nullable().optional(),
  tradepointId: e.number().int().nullable().optional(),
  tradepointName: e.string().nullable().optional(),
  agreementId: e.number().int().nullable().optional(),
  agreementName: e.string().nullable().optional(),
  managerId: e.number().int().nullable().optional(),
  managerName: e.string().nullable().optional(),
  warehouseId: e.number().int().nullable().optional(),
  statusCode: e.string(),
  totalAmount: e.coerce.number(),
  currency: e.string(),
  /** ISO-8601 LocalDate. */
  deliveryDate: e.string().nullable().optional(),
  pending: e.boolean(),
  hasAttachments: e.boolean(),
  /** PA-11 / D17 §2.6: cross-tenant обогащение для PLATFORM_ADMIN.
   *  Для distributor-scoped / client-scoped пользователей — null. */
  distributorId: e.number().int().nullable().optional(),
  distributorSlug: e.string().nullable().optional(),
  distributorDisplayName: e.string().nullable().optional()
}), bn = u(mn), pn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  pending: e.boolean(),
  active: e.boolean()
}), gn = u(pn), yn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  inn: e.string().nullable().optional(),
  kpp: e.string().nullable().optional(),
  active: e.boolean()
}), hn = u(yn), fn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  active: e.boolean()
}), In = u(fn), Sn = e.object({
  id: e.number().int(),
  agreementId: e.number().int(),
  skuExternalId: e.string().uuid(),
  price: e.coerce.number(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional()
}), wn = u(Sn), vn = e.object({
  skuId: e.number().int(),
  /** Внешний UUID-строка из 1С (может содержать '#offer' суффикс — до '#' это productExternalId). */
  externalId: e.string().nullable().optional(),
  productId: e.number().int().nullable().optional(),
  productSlug: e.string().nullable().optional(),
  name: e.string(),
  article: e.string().nullable().optional(),
  finalPrice: e.coerce.number().nullable().optional(),
  basePrice: e.coerce.number().nullable().optional(),
  discountApplied: e.boolean(),
  currency: e.string(),
  totalStock: e.coerce.number(),
  /**
   * Остаток на складе, привязанном к текущей TT (foundation chip
   * «TT-warehouse №1»). {@code null} — TT не привязана к складу
   * (no binding); 0 — связан, но нулевой остаток; положительное число —
   * доступно к моментальной отгрузке. {@code undefined} — backend ещё
   * не отдаёт поле (старый snapshot), UI падает на {@code totalStock}.
   */
  availableQuantity: e.coerce.number().nullable().optional(),
  /**
   * Производный флаг «в наличии» по TT-warehouse binding.
   * {@code undefined} — backend ещё не шипанул foundation.
   */
  isInStock: e.boolean().optional(),
  groupId: e.number().int().nullable().optional(),
  groupName: e.string().nullable().optional(),
  photoUrl: e.string().nullable().optional(),
  syncedAt: e.string().nullable().optional()
}), Pn = u(vn), En = e.object({
  warehouseId: e.number().int(),
  warehouseExternalId: e.string().nullable().optional(),
  warehouseName: e.string().nullable().optional(),
  quantity: e.coerce.number()
}), Tn = e.object({
  skuId: e.number().int(),
  externalId: e.string(),
  name: e.string().nullable().optional(),
  article: e.string().nullable().optional(),
  baseUnit: e.string().nullable().optional(),
  baseUnitCode: e.string().nullable().optional(),
  /** Коэффициент кратности заказа (D14 §6 «Quantity-quantization»). */
  baseUnitRatio: e.coerce.number().nullable().optional(),
  finalPrice: e.coerce.number().nullable().optional(),
  basePrice: e.coerce.number().nullable().optional(),
  discountApplied: e.boolean(),
  discountPercent: e.coerce.number().nullable().optional(),
  currency: e.string(),
  totalStock: e.coerce.number(),
  /**
   * Остаток на складе, привязанном к текущей TT (см. {@link SkuSearchItemSchema}).
   */
  availableQuantity: e.coerce.number().nullable().optional(),
  /** Производный флаг «в наличии» по TT-warehouse binding. */
  isInStock: e.boolean().optional(),
  stocks: e.array(En)
}), An = e.object({
  id: e.number().int(),
  slug: e.string(),
  name: e.string(),
  article: e.string().nullable().optional(),
  description: e.string().nullable().optional(),
  categoryId: e.number().int().nullable().optional(),
  categoryName: e.string().nullable().optional(),
  /** Resolution chain product → category (S30 наполнит). В S29 — пустой массив. */
  photos: e.array(e.string()),
  skus: e.array(Tn)
}), Ke = e.lazy(
  () => e.object({
    id: e.number().int(),
    externalId: e.string(),
    parentId: e.number().int().nullable(),
    name: e.string(),
    archived: e.boolean(),
    children: e.array(Ke)
  })
), On = e.object({
  id: e.number().int(),
  lineNumber: e.number().int(),
  skuExternalId: e.string().uuid(),
  skuId: e.number().int().nullable().optional(),
  skuArticle: e.string().nullable().optional(),
  skuName: e.string().nullable().optional(),
  quantity: e.coerce.number(),
  unitCode: e.string().nullable().optional(),
  price: e.coerce.number(),
  discountPercent: e.coerce.number().nullable().optional(),
  lineTotal: e.coerce.number(),
  /**
   * Позиция «под заказ» — в момент checkout привязанный склад TT не имел
   * остатка по SKU. Выставляется backend'ом автоматически (foundation chip
   * «TT-warehouse №1»). {@code undefined} — backend ещё не шипанул поле.
   */
  isBackorder: e.boolean().optional()
}), Cn = e.object({
  id: e.number().int(),
  statusFrom: e.string().nullable().optional(),
  statusTo: e.string(),
  occurredAt: e.string(),
  actor: e.string().nullable().optional(),
  comment: e.string().nullable().optional()
}), Rn = e.object({
  id: e.number().int(),
  fileName: e.string().nullable().optional(),
  contentType: e.string().nullable().optional(),
  sizeBytes: e.coerce.number(),
  kind: e.string().nullable().optional(),
  sourceRevision: e.number().int().nullable().optional(),
  sourceModifiedAt: e.string().nullable().optional(),
  /** Отсутствует у backend старой версии во время rolling deployment. */
  current: e.boolean().optional()
}), jn = e.object({
  id: e.number().int(),
  editKind: e.string(),
  diff: e.record(e.string(), e.unknown()),
  occurredAt: e.string(),
  sourceSystem: e.string(),
  sourceRevision: e.number().int().nullable().optional(),
  requiresAck: e.boolean(),
  acknowledgedAt: e.string().nullable().optional()
}), te = e.object({
  id: e.number().int(),
  distributorId: e.number().int(),
  externalId: e.string().uuid(),
  documentNumber: e.string().nullable().optional(),
  documentDate: e.string().nullable().optional(),
  createdAt: e.string(),
  updatedAt: e.string().nullable().optional(),
  clientId: e.number().int().nullable().optional(),
  tradepointId: e.number().int().nullable().optional(),
  tradepointName: e.string().nullable().optional(),
  deliveryAddress: e.string().nullable().optional(),
  deliveryDate: e.string().nullable().optional(),
  legalEntityId: e.number().int().nullable().optional(),
  legalEntityName: e.string().nullable().optional(),
  warehouseId: e.number().int().nullable().optional(),
  warehouseName: e.string().nullable().optional(),
  agreementId: e.number().int().nullable().optional(),
  agreementName: e.string().nullable().optional(),
  managerId: e.number().int().nullable().optional(),
  managerName: e.string().nullable().optional(),
  managerPhone: e.string().nullable().optional(),
  managerEmail: e.string().nullable().optional(),
  statusCode: e.string(),
  totalAmount: e.coerce.number(),
  subtotalAmount: e.coerce.number(),
  discountAmount: e.coerce.number(),
  currency: e.string(),
  pending: e.boolean(),
  comment: e.string().nullable().optional(),
  paymentForm: e.string().nullable().optional(),
  legalEntityAddress: e.string().nullable().optional(),
  externalRevision: e.number().int().nullable().optional(),
  lines: e.array(On),
  statusEvents: e.array(Cn),
  attachments: e.array(Rn),
  editEvents: e.array(jn).default([]),
  etag: e.string()
}), qn = e.object({
  skuExternalId: e.string().uuid(),
  skuName: e.string().nullable().optional(),
  reason: e.string()
}), Dn = e.object({
  targetTradepointId: e.number().int(),
  sourceTradepointId: e.number().int().nullable().optional(),
  added: e.number().int().nonnegative(),
  skipped: e.array(qn)
}), me = e.enum([
  "DISTRIBUTOR_ADMIN",
  "DISTRIBUTOR_OWNER",
  "DISTRIBUTOR_MANAGER",
  "DISTRIBUTOR_FIELD_EMPLOYEE"
]), Qe = e.object({
  keycloakSub: e.string(),
  email: e.string().nullable().optional(),
  fullName: e.string().nullable().optional(),
  role: me,
  territoryId: e.number().int().nullable().optional(),
  territoryName: e.string().nullable().optional(),
  managerId: e.string().nullable().optional(),
  managerName: e.string().nullable().optional(),
  // D19-1 / E1.2: связь user → DistributorManager (1С-Сотрудник). Backend
  // (E1.2 §B) будет наполнять — пока optional, frontend безопасно читает.
  distributorManagerId: e.number().int().nullable().optional(),
  distributorManagerName: e.string().nullable().optional(),
  active: e.boolean()
}), V = Qe, $n = e.object({
  email: e.string().email(),
  fullName: e.string().min(1).max(255),
  role: me,
  territoryId: e.number().int().nullable().optional(),
  managerId: e.string().nullable().optional(),
  // D19-1 / E1.2: связь приглашённого MANAGER с 1С-Сотрудником
  // (DistributorManager). Обязательна для роли MANAGER —
  // см. superRefine ниже.
  distributorManagerId: e.number().int().nullable().optional()
}).strict().superRefine((n, a) => {
  n.role === "DISTRIBUTOR_FIELD_EMPLOYEE" && n.territoryId == null && a.addIssue({
    code: e.ZodIssueCode.custom,
    path: ["territoryId"],
    message: "Территория обязательна для FIELD_EMPLOYEE"
  }), n.role === "DISTRIBUTOR_FIELD_EMPLOYEE" && !n.managerId && a.addIssue({
    code: e.ZodIssueCode.custom,
    path: ["managerId"],
    message: "Менеджер обязателен для FIELD_EMPLOYEE"
  }), n.role === "DISTRIBUTOR_MANAGER" && n.distributorManagerId == null && a.addIssue({
    code: e.ZodIssueCode.custom,
    path: ["distributorManagerId"],
    message: "1С-Сотрудник обязателен для роли MANAGER"
  });
}), xn = e.object({
  user: V,
  loginUrl: e.string(),
  temporaryPassword: e.string(),
  emailDispatched: e.boolean()
}), Nn = e.object({
  role: me.optional(),
  territoryId: e.number().int().nullable().optional(),
  managerId: e.string().nullable().optional(),
  // D19-1 / E1.2: смена связи с 1С-Сотрудником (или сброс через null).
  distributorManagerId: e.number().int().nullable().optional()
}).strict(), kn = e.object({
  id: e.number().int().nullable().optional(),
  skuExternalId: e.string().uuid("skuExternalId должен быть UUID"),
  quantity: e.number().positive("Кол-во должно быть больше нуля"),
  unitCode: e.string().max(16).nullable().optional(),
  price: e.number().nonnegative("Цена не может быть отрицательной").optional(),
  discountPercent: e.number().min(0, "Скидка не может быть отрицательной").max(100, "Скидка не более 100%").nullable().optional()
}).strict(), Un = e.object({
  agreementId: e.number().int().nullable().optional(),
  deliveryDate: e.string().nullable().optional(),
  clearDeliveryDate: e.boolean().nullable().optional(),
  deliveryAddress: e.string().max(1e3).nullable().optional(),
  managerId: e.number().int().nullable().optional(),
  comment: e.string().max(4e3).nullable().optional(),
  lines: e.array(kn).nullable().optional()
}).strict(), Ln = e.object({
  reason: e.string().max(1e3).optional()
}).strict(), Mn = e.object({
  clientId: e.number().int().positive(),
  tradepointId: e.number().int().positive(),
  legalEntityId: e.number().int().positive(),
  agreementId: e.number().int().positive(),
  skuId: e.number().int().positive(),
  quantity: e.number().positive(),
  unitPrice: e.number().positive(),
  deliveryDate: e.string().date().nullable().optional(),
  deliveryAddress: e.string().max(1e3).nullable().optional(),
  comment: e.string().max(2e3).nullable().optional()
}).strict(), _n = e.object({
  orderId: e.number().int().positive(),
  documentNumber: e.string().nullable(),
  externalId: e.string().uuid(),
  outboundEventId: e.number().int().positive(),
  statusCode: e.string().min(1)
}), zn = e.enum(["REPRICE", "CANCEL", "REASSIGN_MANAGER", "SET_STATUS"]), Gn = e.object({
  orderIds: e.array(e.number().int().positive()).min(1).max(100),
  action: zn,
  params: e.record(e.string(), e.unknown()).optional()
}).strict(), Bn = e.object({
  orderId: e.number().int().positive(),
  errorCode: e.string(),
  message: e.string().nullable().optional()
}), Vn = e.object({
  successCount: e.number().int().min(0),
  failedCount: e.number().int().min(0),
  failures: e.array(Bn)
}), Hn = e.object({
  clientId: e.number().int().positive(),
  name: e.string().min(1, "Название обязательно").max(255),
  currency: e.string().length(3).optional().nullable(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  paymentTermsDays: e.number().int().min(0).nullable().optional(),
  basePriceTypeExternal: e.string().uuid().nullable().optional()
}).strict(), Fn = e.object({
  id: e.number().int(),
  distributorId: e.number().int(),
  clientId: e.number().int(),
  externalId: e.string().uuid(),
  name: e.string(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  paymentTermsDays: e.number().int().nullable().optional(),
  basePriceTypeExternal: e.string().uuid().nullable().optional(),
  draft: e.boolean(),
  active: e.boolean()
}), Wn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid(),
  clientId: e.number().int(),
  name: e.string(),
  currency: e.string(),
  validFrom: e.string().nullable().optional(),
  validTo: e.string().nullable().optional(),
  active: e.boolean()
}), Yn = e.object({
  id: e.number().int(),
  externalId: e.string().uuid().nullable().optional(),
  fullName: e.string().nullable().optional(),
  email: e.string().nullable().optional(),
  phone: e.string().nullable().optional(),
  positionTitle: e.string().nullable().optional(),
  active: e.boolean()
}), Kn = e.object({
  contacts: e.boolean(),
  logo: e.boolean(),
  territory: e.boolean(),
  invite: e.boolean()
}), Qn = e.object({
  newOrders: e.number().int().nonnegative(),
  pendingOrders: e.number().int().nonnegative(),
  hierarchyWarnings: e.number().int().nonnegative(),
  onboardingCompleted: Kn.nullable()
}), Xn = e.enum([
  "ORDER_NEW",
  "ORDER_EDITED",
  "ORDER_CANCELLED",
  "ORDER_REPRICED",
  "ORDER_STATUS_CHANGED",
  "INVITE_SENT",
  "INVITE_ACCEPTED",
  "INVITE_REVOKED",
  "USER_ROLE_CHANGED",
  "USER_DEACTIVATED",
  "TERRITORY_CREATED",
  "TERRITORY_UPDATED",
  "SETTINGS_UPDATED",
  "LOGO_UPLOADED",
  "AGREEMENT_DRAFT_CREATED",
  "HIERARCHY_WARNING",
  "INTEGRATION_ERROR"
]), Jn = e.object({
  id: e.string(),
  kind: Xn,
  title: e.string(),
  subtitle: e.string().nullable(),
  url: e.string().nullable(),
  actor: e.string(),
  occurredAt: e.string()
}), Zn = e.array(Jn), Xe = e.string().max(64, "Не более 64 символов").optional(), be = e.string().max(255, "Не более 255 символов").refine((n) => n === "" || e.string().email().safeParse(n).success, {
  message: "Некорректный формат email"
}).optional(), ea = e.object({
  contactPhone: Xe,
  contactEmail: be
}).strict(), ta = e.object({
  contactPhone: Xe,
  contactEmail: be,
  address: e.string().max(1024, "Не более 1024 символов").optional()
}).strict(), na = e.object({
  actualAddress: e.string().max(1024, "Не более 1024 символов").optional()
}).strict(), aa = e.object({
  fullName: e.string().max(255, "Не более 255 символов").optional(),
  positionTitle: e.string().max(255, "Не более 255 символов").optional(),
  email: be,
  phonePrimary: e.string().max(64, "Не более 64 символов").optional(),
  phoneSecondary: e.string().max(64, "Не более 64 символов").optional()
}).strict(), ra = e.object({
  id: e.number().int(),
  name: e.string(),
  contactPhone: e.string().nullable().optional(),
  contactEmail: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), ia = e.object({
  id: e.number().int(),
  name: e.string(),
  address: e.string().nullable().optional(),
  contactPhone: e.string().nullable().optional(),
  contactEmail: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), oa = e.object({
  id: e.number().int(),
  name: e.string(),
  inn: e.string(),
  kpp: e.string().nullable().optional(),
  legalAddress: e.string().nullable().optional(),
  actualAddress: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), sa = e.object({
  id: e.number().int(),
  fullName: e.string(),
  positionTitle: e.string().nullable().optional(),
  email: e.string().nullable().optional(),
  phonePrimary: e.string().nullable().optional(),
  phoneSecondary: e.string().nullable().optional(),
  portalOwnedOverlay: e.boolean()
}), la = e.object({
  /** ID шага — один из 8 фиксированных кодов (settings_filled,
   *  credentials_issued, credentials_delivered, first_sync_received,
   *  mass_sync_done, manager_invited, regular_sync_configured,
   *  client_owner_invited). */
  id: e.string(),
  /** Статус шага — рассчитан backend'ом из доменных таблиц. */
  status: e.enum(["done", "pending"])
}), ca = e.object({
  /** `true` ⇔ `distributor.onboarding_completed_at IS NOT NULL`. */
  completed: e.boolean(),
  /** ISO-8601 момент завершения wizard'а; `null`, если ещё не завершён. */
  completedAt: e.string().nullable(),
  /** Массив из 8 шагов (порядок фиксирован backend'ом — фронт может
   *  рендерить «as is»). */
  steps: e.array(la),
  sourceProgress: e.object({
    credentialsIssued: e.boolean(),
    completedRuns: e.number().int().nonnegative(),
    confirmedBundles: e.number().int().nonnegative(),
    clients: e.number().int().nonnegative(),
    tradepoints: e.number().int().nonnegative(),
    payers: e.number().int().nonnegative()
  }).optional(),
  accessProgress: e.object({
    employees: e.number().int().nonnegative(),
    clientOwners: e.number().int().nonnegative()
  }).optional()
}), ua = e.object({
  clients: e.object({
    total: e.number().int().nonnegative(),
    pending: e.number().int().nonnegative()
  }),
  tradepoints: e.object({
    total: e.number().int().nonnegative(),
    withoutLegalEntity: e.number().int().nonnegative()
  }),
  managers: e.object({
    total: e.number().int().nonnegative(),
    withoutEmail: e.number().int().nonnegative()
  }),
  warehouses: e.object({
    total: e.number().int().nonnegative(),
    withStock: e.number().int().nonnegative()
  }),
  agreements: e.object({
    total: e.number().int().nonnegative(),
    withBasePrice: e.number().int().nonnegative()
  }),
  sku: e.object({
    total: e.number().int().nonnegative(),
    withProduct: e.number().int().nonnegative(),
    withStock: e.number().int().nonnegative()
  })
}), da = e.object({
  id: e.number().int(),
  skuId: e.number().int(),
  skuExternalId: e.string(),
  skuArticle: e.string().nullable().optional(),
  skuName: e.string().nullable().optional(),
  unitName: e.string().nullable().optional(),
  /** Коэффициент кратности заказа (D14 §6 «Quantity-quantization»). */
  unitRatio: e.coerce.number().nullable().optional(),
  /** Кол-во в базовых единицах SKU; BigDecimal → coerce. */
  quantity: e.coerce.number(),
  /** Цена за единицу сейчас (recomputed: agreement → price-type → null). */
  unitPrice: e.coerce.number().nullable().optional(),
  basePrice: e.coerce.number().nullable().optional(),
  discountPercent: e.coerce.number().nullable().optional(),
  /** {@code unitPrice * quantity}; null если unitPrice отсутствует. */
  lineTotal: e.coerce.number().nullable().optional(),
  /** Snapshot цены на момент добавления строки (для UI badge «цена изменилась»). */
  snapshotUnitPrice: e.coerce.number().nullable().optional(),
  /** ISO Instant; null если строка добавлена без цены. */
  snapshotPricedAt: e.string().nullable().optional(),
  /**
   * D14 §8 — backend сравнивает {@code unitPrice} с {@code snapshotUnitPrice}
   * и выставляет {@code true} если цена изменилась с момента add-to-cart.
   * UI показывает badge «цена изменилась» pre-emptive (а не ждёт 409 на checkout).
   */
  priceChanged: e.boolean(),
  /** Остаток на TT-primary warehouse; null — нет привязки склада к TT. */
  availableQuantity: e.coerce.number().nullable().optional(),
  isInStock: e.boolean(),
  /**
   * Soft-флаг «под заказ» — TT-warehouse без binding ИЛИ
   * {@code quantity > availableQuantity}. Checkout пропускает, менеджер
   * подтверждает (D14 §7 «Quantity > остатка: soft warning ... checkout проходит»).
   */
  isBackorder: e.boolean(),
  /**
   * Hard-флаг «недоступен» — SKU archived/deleted (D14 §7 «Out-of-stock /
   * archived SKU: помечаем "недоступен", оставляем в строке, не считаем в total,
   * checkout с такой строкой блокирован»). Семантически отличается от
   * {@code isBackorder} — backorder проходит, unavailable блокирует.
   */
  isUnavailable: e.boolean(),
  photoUrl: e.string().nullable().optional()
}), Jr = e.object({
  tradepointId: e.number().int(),
  lines: e.array(da),
  /** Сумма {@code lineTotal} по всем строкам с unitPrice; BigDecimal → coerce. */
  totalAmount: e.coerce.number(),
  /** Сумма {@code quantity} по всем строкам; BigDecimal → coerce. */
  totalQuantity: e.coerce.number(),
  /** Кол-во строк с {@code isBackorder=true} — для total info-banner (D14 §7). */
  backorderCount: e.number().int(),
  /**
   * Кол-во строк с {@code isUnavailable=true} (archived/deleted SKU) —
   * для checkout-blocker banner (D14 §7).
   */
  unavailableCount: e.number().int(),
  currency: e.string()
}), Zr = e.object({
  tradepointId: e.number().int(),
  skuId: e.number().int(),
  quantity: e.number().positive()
}).strict(), ei = e.object({
  quantity: e.number().positive()
}).strict();
async function ti(n, a) {
  const t = await n.request("/me", { token: a });
  return Be.parse(t);
}
async function ni(n, a, t) {
  const r = qt.parse(t), i = await n.request("/me", {
    method: "PATCH",
    token: a,
    body: r
  });
  return Be.parse(i);
}
async function ai(n, a, t) {
  const r = xt.parse(t);
  await n.request("/me/password", {
    method: "POST",
    token: a,
    body: r
  });
}
async function ri(n, a) {
  const t = await n.request("/me/profile", { token: a });
  return Ve.parse(t);
}
async function ii(n, a, t) {
  const r = Dt.parse(t), i = await n.request("/me/profile", {
    method: "PATCH",
    token: a,
    body: r
  });
  return Ve.parse(i);
}
async function oi(n, a, t) {
  const r = $t.parse(t);
  await n.request("/me/email", {
    method: "POST",
    token: a,
    body: r
  });
}
const ma = u(Nt);
async function si(n, a, t) {
  const r = Ut.parse(t), i = await n.request("/invitations", {
    method: "POST",
    token: a,
    body: r
  });
  return Lt.parse(i);
}
async function li(n, a, t = 0, r = 20) {
  const i = await n.request("/invitations", {
    token: a,
    query: { page: t, size: r }
  });
  return ma.parse(i);
}
async function ci(n, a) {
  const t = await n.request(
    `/invitations/by-token/${encodeURIComponent(a)}`
  );
  return Mt.parse(t);
}
async function ui(n, a, t) {
  const r = _t.parse(t);
  await n.request(
    `/invitations/by-token/${encodeURIComponent(a)}/accept`,
    {
      method: "POST",
      body: r
    }
  );
}
async function di(n, a, t) {
  await n.request(`/invitations/${encodeURIComponent(t)}`, {
    method: "DELETE",
    token: a
  });
}
async function mi(n, a) {
  await n.request("/auth/logout", {
    method: "POST",
    token: a
  });
}
async function bi(n, a) {
  const t = await n.request("/integration/1c/health", { token: a });
  return Ht.parse(t);
}
async function pi(n, a) {
  const t = await n.request("/me/exchange-credentials", { token: a });
  return Wt.parse(t);
}
async function gi(n, a) {
  const t = await n.request("/me/exchange-credentials", {
    method: "POST",
    token: a
  });
  return Fe.parse(t);
}
async function yi(n, a, t) {
  await n.request(
    `/admin/exchange-credentials/${t}/revoke`,
    { method: "POST", token: a }
  );
}
async function hi(n, a, t = {}) {
  const r = await n.request("/admin/sync-events", {
    token: a,
    query: {
      distributorId: t.distributorId,
      since: t.since,
      until: t.until,
      // Multi-value: ApiClient повторит ключ для каждого элемента массива (см.
      // config.ts buildUrl). Spring биндит Set<String> из
      // `?responseStatus=success&responseStatus=failure`.
      responseStatus: t.responseStatus,
      type: t.type,
      mode: t.mode,
      requestId: t.requestId,
      errorCategory: t.errorCategory,
      errorCodePrefix: t.errorCodePrefix,
      hasWarnings: t.hasWarnings,
      durationMsMin: t.durationMsMin,
      durationMsMax: t.durationMsMax,
      page: t.page,
      size: t.size ?? 20
    }
  });
  return en(Yt).parse(r);
}
async function fi(n, a, t) {
  const r = await n.request(`/admin/sync-events/${t}`, { token: a });
  return Kt.parse(r);
}
async function Ii(n, a, t = {}) {
  const r = await n.request("/admin/territories", {
    token: a,
    query: {
      name: t.name,
      page: t.page,
      size: t.size
    }
  });
  return u(tn).parse(r);
}
async function Si(n, a, t) {
  const r = await n.request(`/admin/territories/${t}`, { token: a });
  return ee.parse(r);
}
async function wi(n, a, t) {
  const r = rn.parse(t), i = await n.request("/admin/territories", {
    method: "POST",
    token: a,
    body: r
  });
  return ee.parse(i);
}
async function vi(n, a, t, r) {
  const i = on.parse(r), o = await n.request(`/admin/territories/${t}`, {
    method: "PATCH",
    token: a,
    body: i
  });
  return ee.parse(o);
}
async function Pi(n, a, t) {
  await n.request(`/admin/territories/${t}`, {
    method: "DELETE",
    token: a
  });
}
async function Ei(n, a, t, r) {
  const i = sn.parse(r), o = await n.request(`/admin/territories/${t}/tradepoints`, {
    method: "POST",
    token: a,
    body: i
  });
  return ee.parse(o);
}
async function Ti(n, a, t, r) {
  await n.request(
    `/admin/territories/${t}/tradepoints/${r}`,
    { method: "DELETE", token: a }
  );
}
async function Ai(n, a, t = {}) {
  const r = await n.request("/admin/tradepoints", {
    token: a,
    query: {
      name: t.name,
      clientIds: t.clientIds && t.clientIds.length > 0 ? t.clientIds : void 0,
      withoutTerritory: t.withoutTerritory,
      size: t.size ?? 200,
      page: t.page
    }
  });
  return u(cn).parse(r);
}
async function Oi(n, a, t = {}) {
  const r = await n.request("/admin/clients/lookup", {
    token: a,
    query: {
      name: t.name,
      size: t.size ?? 200,
      page: t.page
    }
  });
  return u(ln).parse(r);
}
async function Ci(n, a, t = {}) {
  const r = new URLSearchParams();
  t.distributorId != null && r.set("distributorId", String(t.distributorId)), t.clientId != null && r.set("clientId", String(t.clientId)), t.documentNumber && r.set("documentNumber", t.documentNumber), t.dateFrom && r.set("dateFrom", t.dateFrom), t.dateTo && r.set("dateTo", t.dateTo), t.totalAmountFrom != null && r.set("totalAmountFrom", String(t.totalAmountFrom)), t.totalAmountTo != null && r.set("totalAmountTo", String(t.totalAmountTo)), t.skuExternalId && r.set("skuExternalId", t.skuExternalId), t.page != null && r.set("page", String(t.page)), t.size != null && r.set("size", String(t.size)), t.sort && r.set("sort", t.sort);
  for (const l of t.statusCodes ?? []) r.append("statusCodes", l);
  for (const l of t.tradepointIds ?? []) r.append("tradepointIds", String(l));
  for (const l of t.clientIds ?? []) r.append("clientIds", String(l));
  for (const l of t.territoryIds ?? []) r.append("territoryIds", String(l));
  for (const l of t.managerIds ?? []) r.append("managerIds", String(l));
  const i = r.toString(), o = i.length === 0 ? "/orders" : `/orders?${i}`, s = await n.request(o, { token: a });
  return bn.parse(s);
}
async function Ri(n, a, t = {}) {
  const r = new URLSearchParams();
  r.set("format", "csv"), t.distributorId != null && r.set("distributorId", String(t.distributorId)), t.clientId != null && r.set("clientId", String(t.clientId)), t.documentNumber && r.set("documentNumber", t.documentNumber), t.dateFrom && r.set("dateFrom", t.dateFrom), t.dateTo && r.set("dateTo", t.dateTo), t.totalAmountFrom != null && r.set("totalAmountFrom", String(t.totalAmountFrom)), t.totalAmountTo != null && r.set("totalAmountTo", String(t.totalAmountTo)), t.skuExternalId && r.set("skuExternalId", t.skuExternalId);
  for (const c of t.statusCodes ?? []) r.append("statusCodes", c);
  for (const c of t.tradepointIds ?? []) r.append("tradepointIds", String(c));
  for (const c of t.clientIds ?? []) r.append("clientIds", String(c));
  for (const c of t.territoryIds ?? []) r.append("territoryIds", String(c));
  for (const c of t.managerIds ?? []) r.append("managerIds", String(c));
  const i = `${n.config.baseUrl}/orders/export?${r.toString()}`, o = globalThis.fetch, s = { Accept: "text/csv" };
  a && (s.Authorization = `Bearer ${a}`);
  const l = await o(i, { headers: s });
  if (!l.ok)
    throw new Error(`CSV-экспорт упал: HTTP ${l.status}`);
  return l.blob();
}
async function ji(n, a, t, r) {
  const i = `${n.config.baseUrl}/orders/${t}`, o = n.config.fetch ?? globalThis.fetch, s = { Accept: "application/json" };
  a && (s.Authorization = `Bearer ${a}`), r != null && r.etag && (s["If-None-Match"] = `"${r.etag}"`);
  const l = await o(i, { headers: s });
  if (l.status === 304 && r)
    return { data: r.data, etag: r.etag, notModified: !0 };
  if (!l.ok) {
    let W, Y;
    try {
      const p = await l.json();
      W = p == null ? void 0 : p.message, Y = p == null ? void 0 : p.code;
    } catch {
    }
    throw new $(W ?? `HTTP ${l.status}`, l.status, null, Y);
  }
  const c = await l.json(), d = te.parse(c), M = (l.headers.get("etag") ?? `"${d.etag}"`).replace(/^"|"$/g, "");
  return { data: d, etag: M, notModified: !1 };
}
async function qi(n, a, t, r) {
  const i = r === void 0 ? "" : `?tradepointId=${r}`, o = await n.request(`/orders/${t}/repeat${i}`, {
    method: "POST",
    token: a
  });
  return Dn.parse(o);
}
async function Di(n, a, t, r) {
  await n.request(`/orders/${t}/changes/${r}/ack`, {
    method: "POST",
    token: a
  });
}
function ba(n, a, t) {
  return `${n.config.baseUrl}/orders/${a}/attachments/${t}`;
}
async function $i(n, a, t, r) {
  const i = ba(n, t, r), o = n.config.fetch ?? globalThis.fetch, s = {};
  a && (s.Authorization = `Bearer ${a}`);
  const l = await o(i, { headers: s });
  if (!l.ok)
    throw new $(
      `Не удалось скачать приложение: HTTP ${l.status}`,
      l.status,
      null
    );
  const c = await l.blob(), d = l.headers.get("content-disposition") ?? "", C = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(d), M = C && C[1] ? decodeURIComponent(C[1]) : `attachment-${r}.pdf`;
  return { blob: c, filename: M };
}
async function xi(n, a, t = {}) {
  const r = new URLSearchParams();
  t.q && t.q.trim().length > 0 && r.set("q", t.q.trim()), t.inStock != null && r.set("inStock", String(t.inStock)), t.priceMin != null && r.set("priceMin", String(t.priceMin)), t.priceMax != null && r.set("priceMax", String(t.priceMax)), t.sort && r.set("sort", t.sort), t.tradePointId != null && r.set("tradePointId", String(t.tradePointId)), t.page != null && r.set("page", String(t.page)), t.size != null && r.set("size", String(t.size));
  for (const l of t.groupIds ?? []) r.append("groupIds", String(l));
  const i = r.toString(), o = i.length === 0 ? "/catalog/search" : `/catalog/search?${i}`, s = await n.request(o, { token: a });
  return Pn.parse(s);
}
async function Ni(n, a) {
  const t = await n.request("/catalog/categories", { token: a });
  return e.array(Ke).parse(t);
}
async function ki(n, a, t, r = {}) {
  const i = new URLSearchParams();
  r.tradePointId != null && i.set("tradePointId", String(r.tradePointId));
  const o = i.toString(), s = o.length === 0 ? `/catalog/products/by-slug/${encodeURIComponent(t)}` : `/catalog/products/by-slug/${encodeURIComponent(t)}?${o}`, l = await n.request(s, { token: a });
  return An.parse(l);
}
const pa = e.object({
  skuId: e.number(),
  name: e.string().nullable(),
  article: e.string().nullable(),
  unitCode: e.string().nullable(),
  unitRatio: e.coerce.number().nullable(),
  unitName: e.string().nullable().optional()
}), pe = e.object({
  tradepointId: e.number(),
  lines: e.array(e.object({
    id: e.number(),
    skuId: e.number(),
    quantity: e.string().regex(/^\d+(\.\d+)?$/),
    product: pa.nullable(),
    unavailableReason: e.string().nullable()
  }))
}), ga = e.object({
  membership: e.object({
    id: e.number(),
    distributorId: e.number(),
    subject: e.string(),
    role: e.enum(["CLIENT_OWNER", "CLIENT_EMPLOYEE", "DISTRIBUTOR_OWNER", "DISTRIBUTOR_EMPLOYEE"]),
    clientGroupId: e.number().nullable(),
    sourceManagerId: e.number().nullable(),
    state: e.enum(["PENDING", "ACTIVE", "BLOCKED"]),
    basePermissions: e.array(e.string()),
    version: e.number()
  }),
  permissions: e.array(e.string()),
  pairs: e.array(e.object({ tradepointId: e.number(), payerId: e.number() })),
  tradepoints: e.array(e.object({ id: e.number(), name: e.string(), address: e.string().nullable() })),
  payers: e.array(e.object({ id: e.number(), name: e.string(), inn: e.string().nullable() }))
});
async function Ui(n, a, t) {
  return ga.parse(await n.request("/portal/access/me", { token: a, signal: t }));
}
async function Li(n, a, t, r) {
  return pe.parse(await n.request(
    `/portal/cart/${t}`,
    { token: a, signal: r }
  ));
}
async function Mi(n, a, t) {
  return pe.parse(await n.request(
    `/portal/cart/${t.tradepointId}/lines/${t.skuId}`,
    { token: a, method: "POST", body: { quantity: t.quantity } }
  ));
}
async function _i(n, a, t, r, i) {
  return pe.parse(await n.request(
    `/portal/cart/${t}/lines/${r}`,
    { token: a, method: "PUT", body: i }
  ));
}
async function zi(n, a, t, r) {
  await n.request(`/portal/cart/${t}/lines/${r}`, { token: a, method: "DELETE" });
}
async function Gi(n, a, t) {
  await n.request(`/portal/cart/${t}`, { token: a, method: "DELETE" });
}
async function Bi(n, a, t) {
  const r = Mn.parse(t), i = await n.request("/admin/orders/exchange-test", {
    method: "POST",
    token: a,
    body: r
  });
  return _n.parse(i);
}
const R = e.string().regex(/^\d+(\.\d+)?$/), ya = e.object({
  quoteId: e.string().uuid(),
  expiresAt: e.string(),
  tradepointId: e.number(),
  tradepointName: e.string(),
  payerId: e.number(),
  payerName: e.string(),
  deliveryAddress: e.string(),
  deliveryDate: e.string().nullable(),
  comment: e.string().nullable(),
  currency: e.string(),
  total: R,
  canSubmit: e.boolean(),
  blockers: e.array(e.object({ code: e.string(), message: e.string() })),
  lines: e.array(e.object({
    skuId: e.number(),
    name: e.string(),
    article: e.string().nullable(),
    quantity: R,
    unitCode: e.string(),
    unitName: e.string().nullable().optional(),
    price: R,
    total: R,
    availableQuantity: R,
    stockReceivedAt: e.string(),
    stockCaptureStartedAt: e.string().datetime({ offset: !0 }).nullable().optional().default(null)
  }))
});
async function Vi(n, a, t) {
  return ya.parse(await n.request(
    "/portal/checkout/quotes",
    { token: a, method: "POST", body: t }
  ));
}
async function Hi(n, a, t, r) {
  return e.object({
    orderId: e.number(),
    documentNumber: e.string().nullable(),
    statusCode: e.string(),
    totalAmount: R
  }).parse(await n.request(
    "/portal/checkout/confirm",
    { token: a, method: "POST", body: { quoteId: t, idempotencyKey: r } }
  ));
}
async function Fi(n, a) {
  const t = await n.request("/admin/dashboard/summary", { token: a });
  return Qn.parse(t);
}
async function Wi(n, a) {
  const t = await n.request("/admin/dashboard/activity", { token: a });
  return Zn.parse(t);
}
async function Yi(n, a) {
  const t = await n.request("/admin/distributor/settings", { token: a });
  return B.parse(t);
}
async function Ki(n, a, t) {
  const r = Jt.parse(t), i = await n.request("/admin/distributor/settings", {
    method: "PATCH",
    token: a,
    body: r
  });
  return B.parse(i);
}
async function Qi(n, a, t) {
  const r = new FormData();
  r.append("file", t);
  const i = await n.request("/admin/distributor/settings/logo", {
    method: "POST",
    token: a,
    body: r
  });
  return B.parse(i);
}
async function Xi(n, a) {
  const t = await n.request("/admin/distributor/settings/logo", {
    method: "DELETE",
    token: a
  });
  return B.parse(t);
}
async function Ji(n, a) {
  const t = await n.request("/admin/distributor/price-types", { token: a });
  return e.array(Zt).parse(t);
}
async function Zi(n, a) {
  const t = n.config.baseUrl, r = await fetch(`${t}/admin/distributor/settings/logo`, {
    headers: { Authorization: `Bearer ${a}` }
  });
  if (r.status === 404)
    return null;
  if (!r.ok)
    throw new Error(`Не удалось получить логотип: HTTP ${r.status}`);
  const i = await r.blob();
  return URL.createObjectURL(i);
}
async function eo(n, a) {
  try {
    const t = await n.request("/public/distributor-info", {
      query: { slug: a }
    });
    return Qt.parse(t);
  } catch (t) {
    if (t instanceof $ && t.status === 404)
      return null;
    throw t;
  }
}
function to(n, a) {
  return `${n.config.baseUrl.replace(/\/+$/, "")}/public/distributor-info/logo?slug=${encodeURIComponent(a)}`;
}
const ha = e.object({
  email: e.string(),
  distributorDisplayName: e.string(),
  distributorSlug: e.string(),
  /** ISO-8601 — момент истечения токена. UI может показать «действует до …». */
  expiresAt: e.string(),
  /** Статус инвайта (sent / accepted / expired / revoked / error). Backend
   *  на не-SENT отвечает 410 GONE, поэтому в живом ответе обычно SENT, но
   *  поле оставлено как страховка для будущих режимов. */
  status: e.string()
});
async function no(n, a) {
  const t = await n.request(
    `/public/platform-invitations/${encodeURIComponent(a)}`
  );
  return ha.parse(t);
}
async function ao(n, a, t) {
  await n.request(
    `/public/platform-invitations/${encodeURIComponent(a)}/accept`,
    {
      method: "POST",
      body: { newPassword: t }
    }
  );
}
async function ro(n, a) {
  const t = await n.request("/me/context", { token: a });
  return Ye.parse(t);
}
async function io(n, a, t) {
  const r = dn.parse(t), i = await n.request("/me/context", {
    method: "PATCH",
    token: a,
    body: r
  });
  return Ye.parse(i);
}
async function oo(n, a, t) {
  const r = ea.parse(t), i = await n.request("/me/client/contacts", {
    method: "PATCH",
    token: a,
    body: r
  });
  return ra.parse(i);
}
async function so(n, a, t, r) {
  const i = ta.parse(r), o = await n.request(
    `/me/tradepoints/${t}/contacts`,
    { method: "PATCH", token: a, body: i }
  );
  return ia.parse(o);
}
async function lo(n, a, t, r) {
  const i = na.parse(r), o = await n.request(
    `/me/legal-entities/${t}/contacts`,
    { method: "PATCH", token: a, body: i }
  );
  return oa.parse(o);
}
async function co(n, a, t, r) {
  const i = aa.parse(r), o = await n.request(`/me/contacts/${t}`, {
    method: "PATCH",
    token: a,
    body: i
  });
  return sa.parse(o);
}
function ne(n) {
  const a = new URLSearchParams();
  n.page != null && a.set("page", String(n.page)), n.size != null && a.set("size", String(n.size)), n.sort && a.set("sort", n.sort);
  const t = a.toString();
  return t.length === 0 ? "" : `?${t}`;
}
async function uo(n, a, t = {}) {
  const r = await n.request(`/me/tradepoints${ne(t)}`, {
    token: a
  });
  return gn.parse(r);
}
async function mo(n, a, t = {}) {
  const r = await n.request(`/me/payers${ne(t)}`, {
    token: a
  });
  return hn.parse(r);
}
async function bo(n, a, t = {}) {
  const r = await n.request(`/me/agreements${ne(t)}`, {
    token: a
  });
  return In.parse(r);
}
async function po(n, a, t, r = {}) {
  const i = await n.request(
    `/me/agreements/${t}/personal-prices${ne(r)}`,
    { token: a }
  );
  return wn.parse(i);
}
async function go(n, a, t) {
  const r = `${n.config.baseUrl}/me/agreements/${t}/personal-prices/export?format=csv`, i = globalThis.fetch, o = { Accept: "text/csv" };
  a && (o.Authorization = `Bearer ${a}`);
  const s = await i(r, { headers: o });
  if (!s.ok)
    throw new Error(`CSV-экспорт цен упал: HTTP ${s.status}`);
  return s.blob();
}
async function yo(n, a, t = {}) {
  const r = await n.request("/admin/distributor-users", {
    token: a,
    query: {
      roles: t.roles,
      territoryId: t.territoryId,
      active: t.active,
      search: t.search,
      distributorManagerId: t.distributorManagerId,
      page: t.page,
      size: t.size
    }
  });
  return u(Qe).parse(r);
}
async function ho(n, a, t) {
  const r = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}`,
    { token: a }
  );
  return V.parse(r);
}
async function fo(n, a, t) {
  const r = $n.parse(t), i = await n.request("/admin/distributor-users/invite", {
    method: "POST",
    token: a,
    body: r
  });
  return xn.parse(i);
}
async function Io(n, a, t, r) {
  const i = Nn.parse(r), o = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}`,
    {
      method: "PATCH",
      token: a,
      body: i
    }
  );
  return V.parse(o);
}
async function So(n, a, t) {
  const r = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}/deactivate`,
    { method: "POST", token: a }
  );
  return V.parse(r);
}
async function wo(n, a, t) {
  const r = await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}/activate`,
    { method: "POST", token: a }
  );
  return V.parse(r);
}
async function vo(n, a, t) {
  await n.request(
    `/admin/distributor-users/${encodeURIComponent(t)}`,
    { method: "DELETE", token: a }
  );
}
async function Po(n, a, t, r, i) {
  const o = Un.parse(r), s = await n.request(`/admin/orders/${t}`, {
    method: "PATCH",
    token: a,
    body: o,
    headers: i ? { "If-Match": `"${i}"` } : void 0
  });
  return te.parse(s);
}
async function Eo(n, a, t, r, i) {
  const o = await n.request(`/admin/orders/${t}/reprice`, {
    method: "POST",
    token: a,
    query: r == null ? void 0 : { agreementId: r },
    headers: i ? { "If-Match": `"${i}"` } : void 0
  });
  return te.parse(o);
}
async function To(n, a, t, r = {}, i) {
  const o = Ln.parse(r), s = await n.request(`/admin/orders/${t}/cancel`, {
    method: "POST",
    token: a,
    body: o,
    headers: i ? { "If-Match": `"${i}"` } : void 0
  });
  return te.parse(s);
}
async function Ao(n, a, t) {
  const r = Gn.parse(t), i = await n.request("/admin/orders/bulk", {
    method: "POST",
    token: a,
    body: r
  });
  return Vn.parse(i);
}
const Je = e.object({
  id: e.number(),
  name: e.string(),
  active: e.boolean(),
  portalOwnedOverlay: e.boolean()
}), fa = u(Je);
async function Oo(n, a, t = {}) {
  const r = await n.request("/admin/clients", {
    method: "GET",
    token: a,
    query: {
      overlay: t.overlay,
      includePending: t.includePending,
      // Spring биндит List<Long> из repeated query-параметра с одинаковым именем.
      primaryWarehouseId: t.primaryWarehouseIds,
      page: t.page,
      size: t.size,
      sort: t.sort
    }
  });
  return fa.parse(r);
}
async function Co(n, a, t) {
  await n.request(`/admin/clients/${t}/reset-overlay`, {
    method: "POST",
    token: a
  });
}
async function Ro(n, a, t) {
  await n.request(`/admin/tradepoints/${t}/reset-overlay`, {
    method: "POST",
    token: a
  });
}
async function jo(n, a, t) {
  await n.request(
    `/admin/legal-entities/${t}/reset-overlay`,
    { method: "POST", token: a }
  );
}
async function qo(n, a, t) {
  await n.request(`/admin/contacts/${t}/reset-overlay`, {
    method: "POST",
    token: a
  });
}
async function Do(n, a, t) {
  const r = await n.request(`/admin/clients/${t}`, {
    method: "GET",
    token: a
  });
  return Je.parse(r);
}
async function $o(n, a, t) {
  const r = await n.request(
    `/admin/clients/${t}/tradepoints`,
    { method: "GET", token: a }
  );
  return e.array(zt).parse(r);
}
async function xo(n, a, t, r, i) {
  const o = Gt.parse(i);
  await n.request(
    `/admin/clients/${t}/tradepoints/${r}/warehouse`,
    { method: "PATCH", token: a, body: o }
  );
}
const Ia = u(Bt);
async function No(n, a, t = {}) {
  const r = await n.request("/admin/warehouses", {
    method: "GET",
    token: a,
    query: {
      name: t.name,
      active: t.active,
      page: t.page,
      size: t.size,
      sort: t.sort
    }
  });
  return Ia.parse(r);
}
const Sa = e.object({
  legalEntityId: e.number().nullable(),
  tradepointId: e.number().nullable(),
  clientId: e.number().nullable(),
  confidence: e.number(),
  breakdown: e.array(e.string())
}), wa = e.object({
  candidates: e.array(Sa),
  runAt: e.string(),
  threshold: e.number(),
  algorithmVersion: e.number()
}), va = e.object({
  id: e.number(),
  externalId: e.string(),
  documentNumber: e.string().nullable(),
  /** ISO-8601 OffsetDateTime. */
  documentDate: e.string().nullable(),
  /** ISO-8601 Instant. */
  createdAt: e.string(),
  /** BigDecimal as string — не теряем precision на больших суммах. */
  totalAmount: e.string(),
  currency: e.string(),
  deliveryAddress: e.string().nullable(),
  comment: e.string().nullable(),
  matchCandidates: wa.nullable()
}), Pa = u(va);
async function ko(n, a, t = {}) {
  const r = await n.request("/admin/orders/pending", {
    method: "GET",
    token: a,
    query: {
      page: t.page,
      size: t.size,
      sort: t.sort
    }
  });
  return Pa.parse(r);
}
const Ea = e.object({
  clientId: e.number(),
  tradepointId: e.number(),
  legalEntityId: e.number(),
  warehouseId: e.number().optional().nullable(),
  managerId: e.number().optional().nullable()
});
async function Uo(n, a, t, r) {
  const i = Ea.parse(r);
  await n.request(`/admin/orders/${t}/link`, {
    method: "POST",
    token: a,
    body: i
  });
}
const Ta = e.object({
  id: e.number().int(),
  slug: e.string(),
  externalId: e.string(),
  name: e.string(),
  article: e.string().nullable(),
  barcode: e.string().nullable(),
  categoryId: e.number().int().nullable(),
  categoryName: e.string().nullable(),
  isPublished: e.boolean(),
  hasOwnPhoto: e.boolean(),
  photoCount: e.number().int().nonnegative()
}), Aa = u(Ta), Ze = e.object({
  id: e.number().int(),
  storageKey: e.string(),
  sortOrder: e.number().int().nonnegative(),
  altText: e.string().nullable()
}), et = e.object({
  id: e.number().int(),
  storageKey: e.string(),
  sortOrder: e.number().int().nonnegative(),
  altText: e.string().nullable(),
  createdAt: e.string()
}), Oa = e.object({
  affected: e.number().int().nonnegative(),
  skipped: e.number().int().nonnegative()
}), Ca = e.object({
  slug: e.string().min(1, "Slug не может быть пустым").max(96, "Slug не должен быть длиннее 96 символов").regex(
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    "Slug должен состоять из строчных букв, цифр и дефисов"
  )
}).strict(), Ra = e.object({
  published: e.boolean()
}).strict();
async function Lo(n, a, t = {}) {
  const r = {};
  t.categoryId != null && (r.categoryId = t.categoryId), t.published != null && (r.published = t.published), t.hasPhoto != null && (r.hasPhoto = t.hasPhoto), t.orphanSku != null && (r.orphanSku = t.orphanSku), t.search && t.search.trim().length > 0 && (r.search = t.search.trim()), t.page != null && (r.page = t.page), t.size != null && (r.size = t.size);
  const i = await n.request("/admin/catalog/products", {
    token: a,
    query: r
  });
  return Aa.parse(i);
}
async function Mo(n, a, t) {
  const r = await n.request(
    `/admin/catalog/products/${t}/photos`,
    { token: a }
  );
  return e.array(et).parse(r);
}
async function _o(n, a, t) {
  const r = await n.request(
    `/admin/catalog/categories/${t}/photos`,
    { token: a }
  );
  return e.array(et).parse(r);
}
async function zo(n, a, t) {
  const r = n.config.baseUrl, i = await fetch(`${r}/admin/catalog/photos/${t}/binary`, {
    headers: { Authorization: `Bearer ${a}` }
  });
  if (!i.ok)
    throw new Error(`Не удалось получить фото #${t}: HTTP ${i.status}`);
  const o = await i.blob();
  return URL.createObjectURL(o);
}
async function Go(n, a, t, r, i = {}) {
  const o = new FormData();
  o.append("file", r), i.sortOrder != null && o.append("sortOrder", String(i.sortOrder)), i.altText != null && o.append("altText", i.altText);
  const s = await n.request(
    `/admin/catalog/products/${t}/photos`,
    { method: "POST", token: a, body: o }
  );
  return Ze.parse(s);
}
async function Bo(n, a, t, r) {
  await n.request(
    `/admin/catalog/products/${t}/photos/${r}`,
    { method: "DELETE", token: a }
  );
}
async function Vo(n, a, t, r, i = {}) {
  const o = new FormData();
  o.append("file", r), i.sortOrder != null && o.append("sortOrder", String(i.sortOrder)), i.altText != null && o.append("altText", i.altText);
  const s = await n.request(
    `/admin/catalog/categories/${t}/photos`,
    { method: "POST", token: a, body: o }
  );
  return Ze.parse(s);
}
async function Ho(n, a, t, r) {
  await n.request(
    `/admin/catalog/categories/${t}/photos/${r}`,
    { method: "DELETE", token: a }
  );
}
async function Fo(n, a, t, r) {
  const i = await n.request(
    `/admin/catalog/categories/${t}/apply-photos-to-products`,
    { method: "POST", token: a, query: { force: r } }
  );
  return Oa.parse(i);
}
async function Wo(n, a, t, r) {
  const i = Ra.parse({ published: r });
  await n.request(
    `/admin/catalog/products/${t}/publication`,
    { method: "PATCH", token: a, body: i }
  );
}
async function Yo(n, a, t, r) {
  const i = Ca.parse({ slug: r });
  await n.request(`/admin/catalog/products/${t}/slug`, {
    method: "PATCH",
    token: a,
    body: i
  });
}
const ja = ["provisioning", "active", "archived"], H = e.string().transform((n) => n.toLowerCase()).pipe(e.enum(ja)), qa = ["sent", "accepted", "expired", "revoked", "error"], tt = e.string().transform((n) => n.toLowerCase()).pipe(e.enum(qa)), Da = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: H,
  /** ISO-8601 — дата создания записи `distributor`. */
  createdAt: e.string(),
  /** ISO-8601 — последний логин первого OWNER'а (null если ни разу). */
  lastOwnerLoginAt: e.string().nullable().optional(),
  /** ISO-8601 — последний успешный sync 1С (null если ни разу). */
  lastSyncAt: e.string().nullable().optional(),
  /** Кол-во заказов за сегодня. */
  ordersToday: e.number().int().nonnegative().default(0)
}), $a = u(Da), xa = e.object({
  cardCreatedAt: e.string().nullable().optional(),
  subdomainReadyAt: e.string().nullable().optional(),
  inviteSentAt: e.string().nullable().optional(),
  ownerAcceptedAt: e.string().nullable().optional(),
  credentialsIssuedAt: e.string().nullable().optional(),
  firstSyncAt: e.string().nullable().optional()
}), Na = e.object({
  userId: e.string().nullable().optional(),
  email: e.string(),
  firstName: e.string().nullable().optional(),
  lastName: e.string().nullable().optional(),
  inviteStatus: tt,
  inviteSentAt: e.string().nullable().optional(),
  inviteAcceptedAt: e.string().nullable().optional(),
  inviteExpiresAt: e.string().nullable().optional()
}), ge = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: H,
  inn: e.string().nullable().optional(),
  generalPhone: e.string().nullable().optional(),
  generalEmail: e.string().nullable().optional(),
  generalOfficeAddress: e.string().nullable().optional(),
  createdAt: e.string(),
  /** Можно ли выполнить hard-delete (D16 §2.3) — backend сам считает: нет
   *  accepted invite И нет sync_event записей. */
  canHardDelete: e.boolean(),
  checklist: xa,
  owner: Na.nullable().optional()
}), ka = e.object({
  slug: e.string(),
  available: e.boolean(),
  /** Локализованная причина если не available (например «slug занят»,
   *  «slug зарезервирован»). */
  reason: e.string().nullable().optional()
}), Ua = /^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$/, La = e.object({
  slug: e.string().min(3, "Slug должен быть не короче 3 символов").max(32, "Slug должен быть не длиннее 32 символов").regex(
    Ua,
    "Только lowercase, цифры и дефисы; не может начинаться или заканчиваться дефисом"
  ),
  displayName: e.string().min(1, "Укажите название тенанта").max(255),
  inn: e.string().regex(/^\d{10}$|^\d{12}$/, "ИНН должен содержать 10 или 12 цифр"),
  generalPhone: e.string().max(64).optional().nullable(),
  generalEmail: e.string().email("Некорректный email").optional().nullable(),
  generalOfficeAddress: e.string().max(500).optional().nullable(),
  ownerEmail: e.string().email("Некорректный email OWNER").max(255),
  ownerFirstName: e.string().min(1, "Укажите имя OWNER").max(120),
  ownerLastName: e.string().min(1, "Укажите фамилию OWNER").max(120),
  /** Если ИНН уже занят другим тенантом — backend вернёт 409 с warning
   *  kind='duplicate_inn'. После подтверждения пользователем — клиент
   *  повторяет POST с этим флагом, и backend записывает (D16 §2.6). */
  confirmDuplicateInn: e.boolean().optional()
}).strict(), Ma = e.object({
  kind: e.literal("duplicate_inn"),
  existingDistributor: e.object({
    id: e.number().int(),
    displayName: e.string(),
    slug: e.string()
  })
}), _a = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: H,
  ownerUserId: e.string(),
  /** URL на welcome-страницу admin SPA с onboarding-token; PA копирует и
   *  шлёт OWNER через защищённый канал (Telegram / WhatsApp). По клику OWNER
   *  попадает на нашу welcome-форму, задаёт пароль и логинится. */
  inviteLink: e.string().url().nullable().optional(),
  /** D16-v2: SMTP отключён → всегда false. Оставлено в схеме для backward
   *  compatibility с уже задеплоенным backend; UI не использует. */
  smtpFallback: e.boolean().default(!1),
  /** Заполняется при confirmed duplicate_inn (D16 §2.6). UI рендерит
   *  info-banner и редиректит на карточку. */
  warning: Ma.nullable().optional()
}), za = e.object({
  invitationId: e.number().int(),
  status: tt,
  sentAt: e.string(),
  expiresAt: e.string(),
  /** URL на welcome-страницу admin SPA с onboarding-token; PA копирует и
   *  шлёт OWNER через защищённый канал. */
  inviteLink: e.string().url().nullable().optional(),
  /** D16-v2: SMTP отключён → всегда false. Поле оставлено для backward compat. */
  smtpFallback: e.boolean().default(!1)
}), Ga = e.object({
  ownerEmail: e.string().email("Некорректный email").max(255),
  ownerFirstName: e.string().min(1, "Укажите имя OWNER").max(128),
  ownerLastName: e.string().min(1, "Укажите фамилию OWNER").max(128)
}).strict(), Ba = e.object({
  distributorId: e.number().int(),
  newOwnerSub: e.string(),
  previousOwnerSubs: e.array(e.string()).default([]),
  invitationId: e.number().int(),
  /** URL на welcome-страницу admin SPA с onboarding-token; PA копирует и
   *  шлёт OWNER через защищённый канал. */
  inviteLink: e.string().url().nullable().optional(),
  /** D16-v2: SMTP отключён → всегда false. Поле оставлено для backward compat. */
  smtpFallback: e.boolean().default(!1)
}), Va = e.object({
  status: H,
  comment: e.string().min(1, "Укажите причину изменения статуса").max(2e3)
}).strict();
async function Ko(n, a, t = {}) {
  const r = await n.request("/admin/platform/distributors", {
    token: a,
    query: {
      status: t.status,
      search: t.search,
      stuckSinceDays: t.stuckSinceDays,
      page: t.page,
      size: t.size
    }
  });
  return $a.parse(r);
}
async function Qo(n, a, t) {
  const r = await n.request(`/admin/platform/distributors/${t}`, {
    token: a
  });
  return ge.parse(r);
}
async function Xo(n, a, t) {
  const r = await n.request("/admin/platform/distributors/check", {
    token: a,
    query: { slug: t }
  });
  return ka.parse(r);
}
async function Jo(n, a, t) {
  const r = La.parse(t), i = await n.request("/admin/platform/distributors", {
    method: "POST",
    token: a,
    body: r
  });
  return _a.parse(i);
}
async function Zo(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/invitations/resend`,
    { method: "POST", token: a }
  );
  return za.parse(r);
}
async function es(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/archive`,
    { method: "POST", token: a }
  );
  return ge.parse(r);
}
async function ts(n, a, t) {
  await n.request(`/admin/platform/distributors/${t}`, {
    method: "DELETE",
    token: a
  });
}
async function ns(n, a, t, r) {
  const i = Va.parse(r), o = await n.request(
    `/admin/platform/distributors/${t}/status`,
    { method: "POST", token: a, body: i }
  );
  return ge.parse(o);
}
async function as(n, a, t, r) {
  const i = Ga.parse(r), o = await n.request(
    `/admin/platform/distributors/${t}/owner`,
    { method: "POST", token: a, body: i }
  );
  return Ba.parse(o);
}
function rs(n) {
  const a = n.trim();
  if (a.length !== 10 && a.length !== 12 || !/^\d+$/.test(a)) return !1;
  const t = a.split("").map((o) => Number(o));
  if (a.length === 10)
    return ce(t, [2, 4, 10, 3, 5, 9, 4, 6, 8]) === t[9];
  const r = ce(t, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]), i = ce(t, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
  return r === t[10] && i === t[11];
}
function ce(n, a) {
  let t = 0;
  for (let r = 0; r < a.length; r++)
    t += n[r] * a[r];
  return t % 11 % 10;
}
const Ha = e.object({
  id: e.number().int(),
  slug: e.string(),
  displayName: e.string(),
  status: H
}), Fa = e.object({
  id: e.number().int(),
  documentNumber: e.string(),
  distributorId: e.number().int(),
  distributorSlug: e.string(),
  /** Backend сериализует `OrderStatus#name()` lowercase'ом (см. order-domain),
   *  но защищаемся от UPPERCASE'а на случай drift'а — нормализуем тут же. */
  statusCode: e.string().transform((n) => n.toLowerCase()),
  /** ISO-8601 OffsetDateTime создания заказа. */
  createdAt: e.string()
}), Wa = e.object({
  distributors: e.array(Ha).default([]),
  orders: e.array(Fa).default([])
});
async function is(n, a, t) {
  const r = await n.request("/admin/platform/search", {
    token: a,
    query: { q: t }
  });
  return Wa.parse(r);
}
const Ya = e.object({
  id: e.number().int(),
  documentNumber: e.string(),
  /** Backend сериализует `OrderStatus#name()` lowercase'ом, но защищаемся от
   *  UPPERCASE-drift'а — нормализуем тут же (как в platform-search). */
  statusCode: e.string().transform((n) => n.toLowerCase()),
  /** Сумма заказа в копейках/рублях — Zod парсит number; backend отдаёт BigDecimal
   *  через Jackson как scalar (без { value }). */
  totalAmount: e.number(),
  currency: e.string(),
  /** ISO-8601 момент создания заказа (`Instant.toString()`). */
  createdAt: e.string()
}), Ka = e.object({
  id: e.number().int(),
  name: e.string(),
  active: e.boolean(),
  pending: e.boolean()
}), Qa = e.object({
  id: e.number().int(),
  name: e.string(),
  /** Address optional — у некоторых ТТ его нет (1С не присылает). */
  address: e.string().nullable().optional(),
  clientId: e.number().int(),
  active: e.boolean()
}), Xa = e.object({
  id: e.number().int(),
  name: e.string().nullable().optional(),
  article: e.string().nullable().optional(),
  /** Может быть null для orphan-Sku (D07 — не сматчен с Product). */
  productId: e.number().int().nullable().optional()
}), Ja = e.object({
  orders: e.array(Ya).default([]),
  clients: e.array(Ka).default([]),
  tradepoints: e.array(Qa).default([]),
  skus: e.array(Xa).default([]),
  totalHits: e.number().int().default(0)
});
async function os(n, a, t) {
  const r = await n.request("/admin/search", {
    token: a,
    query: { q: t }
  });
  return Ja.parse(r);
}
async function ss(n, a, t = {}) {
  const r = await n.request("/admin/agreements", {
    token: a,
    query: {
      clientId: t.clientId,
      active: t.active,
      name: t.name,
      page: t.page,
      size: t.size
    }
  });
  return u(Wn).parse(r);
}
async function ls(n, a, t) {
  const r = Hn.parse(t), i = await n.request("/admin/agreements/draft", {
    method: "POST",
    token: a,
    body: r
  });
  return Fn.parse(i);
}
async function cs(n, a, t = {}) {
  const r = await n.request("/admin/managers", {
    token: a,
    query: {
      fullName: t.fullName,
      email: t.email,
      active: t.active,
      page: t.page,
      size: t.size
    }
  });
  return u(Yn).parse(r);
}
const Za = e.object({
  id: e.number().int(),
  /** Тип операции, например `create_distributor` / `archive_distributor`. */
  action: e.string(),
  /** ID тенанта-цели; null для bootstrap-операций PA. */
  targetDistributorId: e.number().int().nullable().optional(),
  /** Subdomain slug тенанта-цели (batch-resolved); null если тенант удалён. */
  targetDistributorSlug: e.string().nullable().optional(),
  /** Человеческое название тенанта-цели; null при тех же условиях. */
  targetDistributorDisplayName: e.string().nullable().optional(),
  /** ISO-8601 Instant — когда выполнена операция (UTC). */
  performedAt: e.string(),
  /** KC sub PA, выполнившего операцию. */
  performedByUserId: e.string().uuid(),
  /** Snapshot username'а PA на момент операции (KC username мутабельный). */
  performedByUsername: e.string(),
  /** Человеко-читаемое имя PA — резолвится бекендом через KC (приоритет
   *  firstName+lastName → email → username). null если KC недоступен или
   *  user удалён; в этом случае frontend деградирует на performedByUsername.
   *  Audit follow-up post-merge review D-08 (зеркалит UX-DO-04/05 для
   *  distributor audit-log'а из PR #190). */
  performedByDisplayName: e.string().nullable().optional(),
  /** Свободные метаданные операции (payload JSONB как есть). Будущая
   *  redaction чувствительных полей — Phase 2 (D16 §2.13). */
  payload: e.record(e.unknown()).nullable().optional()
}), nt = u(Za);
async function us(n, a, t = {}) {
  const r = await n.request("/admin/platform/audit-log", {
    token: a,
    query: {
      actor: t.actor,
      action: t.action,
      targetDistributorId: t.targetDistributorId,
      since: t.since,
      until: t.until,
      page: t.page,
      size: t.size
    }
  });
  return nt.parse(r);
}
async function ds(n, a, t, r = {}) {
  const i = await n.request(
    `/admin/platform/distributors/${t}/audit-log`,
    {
      token: a,
      query: {
        actor: r.actor,
        action: r.action,
        since: r.since,
        until: r.until,
        page: r.page,
        size: r.size
      }
    }
  );
  return nt.parse(i);
}
const at = e.object({
  id: e.number().int(),
  /** Тип операции (например invite_sent / order_edited / territory_created). */
  action: e.string(),
  /** Тип цели (user / order / settings / territory / agreement / ...);
   *  null для безтаргетных событий. */
  targetKind: e.string().nullable().optional(),
  /** ID цели; null для безтаргетных событий. */
  targetId: e.number().int().nullable().optional(),
  /** KC sub actor'а. */
  actorUserId: e.string(),
  /** Человеко-читаемое имя actor'а (full_name / email из user_link).
   *  null если sub не сматчен в user_link — UI деградирует в short-UUID /
   *  «(Система)». UX-DO-04/05 follow-up. */
  actorDisplayName: e.string().nullable().optional(),
  /** Snapshot realm-роли actor'а на момент действия
   *  (DISTRIBUTOR_OWNER / DISTRIBUTOR_MANAGER / ...). */
  actorRole: e.string(),
  /** ISO-8601 — когда выполнена операция (UTC). */
  occurredAt: e.string(),
  /** Свободные метаданные (payload JSONB как есть). */
  payload: e.record(e.unknown()).nullable().optional()
}), er = u(at);
async function ms(n, a, t = {}) {
  const r = await n.request("/admin/audit-log", {
    token: a,
    query: {
      actorUserId: t.actorUserId,
      action: t.action,
      actionPrefix: t.actionPrefix,
      targetKind: t.targetKind,
      since: t.since,
      until: t.until,
      page: t.page,
      size: t.size
    }
  });
  return er.parse(r);
}
async function bs(n, a, t) {
  const r = await n.request(`/admin/audit-log/${t}`, { token: a });
  return at.parse(r);
}
async function ps(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/exchange-credentials/issue`,
    { method: "POST", token: a }
  );
  return Fe.parse(r);
}
async function gs(n, a, t) {
  await n.request(
    `/admin/platform/exchange-credentials/${t}/revoke`,
    { method: "POST", token: a }
  );
}
const tr = e.object({
  keycloakSub: e.string(),
  email: e.string(),
  fullName: e.string().nullable(),
  /** "OWNER" | "ADMIN" | "MANAGER" | "FIELD_EMPLOYEE" — но backend может
   *  расширить список ролей, поэтому здесь свободная строка. */
  primaryRole: e.string(),
  territoryName: e.string().nullable(),
  active: e.boolean(),
  /** ISO-8601 — дата создания KC-пользователя. */
  createdAt: e.string()
});
async function ys(n, a, t, r = {}) {
  const i = await n.request(
    `/admin/platform/distributors/${t}/users`,
    { token: a, query: { page: r.page, size: r.size } }
  );
  return u(tr).parse(i);
}
async function hs(n, a, t) {
  const r = await n.request(
    `/admin/platform/distributors/${t}/settings`,
    { token: a }
  );
  return B.parse(r);
}
const nr = e.enum([
  "HIERARCHY_WARNING",
  "SYNC_ERROR",
  "PENDING_ORDER",
  "INVITE_ACCEPTED",
  "PLATFORM_TENANT_ACTIVATED",
  "PLATFORM_SYNC_FAILURE"
]), ar = e.object({
  id: e.number().int(),
  kind: nr,
  title: e.string(),
  /** Расширенное описание / контекст; может отсутствовать. */
  body: e.string().nullable().optional(),
  /**
   * Внутренний URL admin SPA для перехода (например `/orders/pending`).
   *
   * Hardening (P1-C2 post-merge audit): принимаем только относительные пути,
   * начинающиеся с одного `/`, не с `//`. Защита от open-redirect: если
   * backend (по багу или атаке) подсунет `https://evil.example/phish` или
   * protocol-relative `//evil.example/...`, zod вернёт `undefined` (через
   * `.catch(undefined)`), и frontend безопасно проигнорирует это поле.
   */
  linkUrl: e.string().regex(/^\/(?!\/)/, "linkUrl должен быть относительным путём, начинающимся с /").nullable().optional().catch(void 0),
  /** ISO-8601 — когда событие произошло (UTC). */
  occurredAt: e.string(),
  /** ISO-8601 — когда отмечено прочитанным; `null` для непрочитанных. */
  readAt: e.string().nullable().optional()
}), rr = u(ar), ir = e.object({
  count: e.number().int().nonnegative()
}), or = e.object({
  marked: e.number().int().nonnegative()
});
async function fs(n, a, t = {}) {
  const r = await n.request("/admin/notifications", {
    token: a,
    query: {
      unreadOnly: t.unreadOnly,
      kind: t.kind,
      page: t.page,
      size: t.size
    }
  });
  return rr.parse(r);
}
async function Is(n, a, t) {
  await n.request(`/admin/notifications/${t}/read`, {
    token: a,
    method: "POST"
  });
}
async function Ss(n, a) {
  const t = await n.request("/admin/notifications/read-all", {
    token: a,
    method: "POST"
  });
  return or.parse(t);
}
async function ws(n, a) {
  const t = await n.request("/admin/notifications/unread-count", {
    token: a
  });
  return ir.parse(t);
}
async function vs(n, a) {
  const t = await n.request("/admin/onboarding/state", { token: a });
  return ca.parse(t);
}
async function Ps(n, a) {
  await n.request("/admin/onboarding/complete", { token: a, method: "POST" });
}
async function Es(n, a) {
  await n.request("/admin/onboarding/mark-credentials-delivered", {
    token: a,
    method: "POST"
  });
}
async function Ts(n, a) {
  const t = await n.request("/admin/sync-state/summary", { token: a });
  return ua.parse(t);
}
const Ue = e.object({
  externalId: e.string().uuid(),
  name: e.string(),
  active: e.boolean(),
  deliveryAddress: e.string().nullable()
}), sr = e.object({
  externalId: e.string().uuid(),
  ownerExternalId: e.string().uuid(),
  name: e.string(),
  inn: e.string().nullable(),
  active: e.boolean()
}), ae = e.object({
  id: e.string().uuid(),
  connectionId: e.string().uuid(),
  runId: e.string().uuid(),
  version: e.number().int().nonnegative(),
  clientId: e.number().nullable(),
  createdAt: e.string(),
  confirmedAt: e.string().nullable(),
  snapshot: e.object({
    client: Ue,
    tradepoints: e.array(Ue),
    payers: e.array(sr),
    warnings: e.array(e.string()).default([])
  })
}), lr = e.object({
  content: e.array(e.object({ externalId: e.string(), payload: e.record(e.unknown()) })),
  totalElements: e.number().int().nonnegative(),
  totalPages: e.number().int().nonnegative()
});
async function As(n, a, t, r, i, o) {
  const s = e.string().uuid().parse(t.connectionId), l = e.string().uuid().parse(t.runId);
  return lr.parse(await n.request(
    `/portal/source-runs/${s}/${l}/objects`,
    { token: a, query: { dataset: r, search: i, page: o, size: 20 } }
  ));
}
async function Os(n, a, t) {
  return ae.parse(await n.request("/portal/mapping/previews", {
    token: a,
    method: "POST",
    body: t
  }));
}
async function Cs(n, a, t) {
  const r = e.string().uuid().parse(t.id);
  return ae.parse(await n.request(`/portal/mapping/previews/${r}/confirm`, {
    token: a,
    method: "POST",
    body: { expectedVersion: t.version }
  }));
}
async function Rs(n, a, t) {
  const r = e.string().uuid().parse(t);
  return ae.parse(await n.request(`/portal/mapping/previews/${r}`, { token: a }));
}
const cr = e.enum([
  "PARTNERS",
  "PAYERS",
  "MANAGERS",
  "CATEGORIES",
  "PRODUCTS",
  "SKUS",
  "PRICE_TYPES",
  "PRICES",
  "WAREHOUSES",
  "STOCKS",
  "ORDER_HISTORY",
  "AGREEMENTS",
  "CONTACTS"
]), ye = e.object({ connectionId: e.string().uuid(), runId: e.string().uuid() }), ur = ye.extend({
  completed: e.boolean(),
  createdAt: e.string().nullable(),
  completedAt: e.string().nullable()
}), dr = e.object({
  content: e.array(ur),
  totalPages: e.number().int().nonnegative(),
  number: e.number().int().nonnegative(),
  totalElements: e.number().int().nonnegative()
}), mr = ye.extend({
  completed: e.boolean(),
  datasets: e.array(e.object({
    dataset: cr,
    expectedObjects: e.number().int().nonnegative(),
    expectedChunks: e.number().int().nonnegative(),
    notApplicable: e.boolean(),
    receivedObjects: e.number().int().nonnegative(),
    receivedChunks: e.number().int().nonnegative(),
    completed: e.boolean()
  }))
});
async function js(n, a, t = 0) {
  return dr.parse(await n.request("/portal/source-runs", {
    token: a,
    query: { page: t, size: 20 }
  }));
}
async function qs(n, a, t) {
  const r = ye.parse(t);
  return mr.parse(await n.request(
    `/portal/source-runs/${r.connectionId}/${r.runId}`,
    { token: a }
  ));
}
const rt = e.object({
  id: e.number().int().positive(),
  name: e.string(),
  active: e.boolean(),
  version: e.number().int().nonnegative()
}), it = e.object({
  clientId: e.number().int().positive(),
  name: e.string(),
  sourceExternalId: e.string().uuid(),
  previewId: e.string().uuid()
}), br = e.object({
  content: e.array(rt),
  totalPages: e.number().int(),
  totalElements: e.number().int()
}), pr = e.object({
  content: e.array(it),
  totalPages: e.number().int(),
  totalElements: e.number().int()
});
async function Ds(n, a, t, r) {
  return br.parse(await n.request("/portal/client-groups", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
async function $s(n, a, t, r) {
  return pr.parse(await n.request("/portal/client-groups/candidates", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
async function xs(n, a, t, r) {
  return rt.parse(await n.request("/portal/client-groups", {
    token: a,
    method: "POST",
    body: { name: t, clientIds: r }
  }));
}
async function Ns(n, a, t) {
  return e.number().int().positive().parse(t), e.array(it).parse(await n.request(`/portal/client-groups/${t}/clients`, { token: a }));
}
const g = e.number().int().positive(), w = e.string().uuid(), he = e.enum(["CLIENT_OWNER", "CLIENT_EMPLOYEE"]), ot = e.object({ tradepointId: g, payerId: g }), fe = e.object({
  id: w,
  groupId: g,
  role: he,
  email: e.string(),
  name: e.string(),
  expiresAt: e.string().datetime({ offset: !0 }),
  state: e.enum(["PENDING", "ACCEPTED", "REVOKED", "EXPIRED"]),
  pairs: e.array(ot),
  equalGroupOwner: e.boolean(),
  canCreateOrders: e.boolean()
}), gr = e.object({
  tradepointId: g,
  tradepointName: e.string().nullable(),
  address: e.string().nullable(),
  payerId: g,
  payerName: e.string().nullable(),
  inn: e.string().nullable()
}), yr = e.object({
  invitation: fe,
  groupName: e.string(),
  distributorName: e.string().nullable(),
  distributorSubdomain: e.string(),
  pairLabels: e.array(gr)
}), F = e.object({
  id: g,
  distributorId: g,
  subject: w,
  role: e.enum(["CLIENT_OWNER", "CLIENT_EMPLOYEE", "DISTRIBUTOR_OWNER", "DISTRIBUTOR_EMPLOYEE"]),
  clientGroupId: g.nullable(),
  sourceManagerId: g.nullable(),
  state: e.enum(["PENDING", "ACTIVE", "BLOCKED"]),
  basePermissions: e.array(e.string()),
  version: e.number().int().nonnegative()
}), hr = e.object({
  requestId: w,
  groupId: g,
  role: he,
  email: e.string().trim().email().max(254),
  name: e.string().trim().min(1).max(200),
  pairs: e.array(ot).max(500),
  canCreateOrders: e.boolean(),
  confirmsOwnerAccess: e.boolean()
});
async function ks(n, a, t) {
  return e.object({ invitation: fe, token: w }).parse(
    await n.request("/portal/group-invitations", {
      token: a,
      method: "POST",
      body: hr.parse(t)
    })
  );
}
async function Us(n, a, t, r) {
  return e.array(fe).parse(await n.request("/portal/group-invitations", {
    token: a,
    query: { groupId: g.parse(t), role: he.parse(r) }
  }));
}
async function Ls(n, a, t) {
  await n.request(`/portal/group-invitations/${w.parse(t)}`, { token: a, method: "DELETE" });
}
async function Ms(n, a, t) {
  return yr.parse(await n.request(
    `/invitations/by-token/${w.parse(a)}/group`,
    {
      signal: t,
      cache: "no-store",
      referrerPolicy: "no-referrer"
    }
  ));
}
async function _s(n, a, t, r) {
  const i = e.object({ password: e.string().min(8).max(128), consent: e.literal(!0) }).parse({ password: t, consent: r });
  return e.object({ status: e.enum(["LOGIN_REQUIRED", "LOGIN_EXISTING_ACCOUNT"]) }).parse(
    await n.request(`/invitations/by-token/${w.parse(a)}/group/register`, {
      method: "POST",
      body: i,
      cache: "no-store",
      referrerPolicy: "no-referrer"
    })
  );
}
async function zs(n, a, t) {
  return F.parse(await n.request(
    `/invitations/by-token/${w.parse(t)}/group/accept`,
    {
      token: a,
      method: "POST",
      body: { confirmed: !0 },
      cache: "no-store",
      referrerPolicy: "no-referrer"
    }
  ));
}
function Gs(n, a) {
  const t = new URL("/group-invite", n);
  if (!["https:", "http:"].includes(t.protocol)) throw new Error("Нужен HTTP(S) адрес портала");
  return t.hash = w.parse(a), t.toString();
}
const fr = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
class j extends Error {
}
function st(n) {
  try {
    return n ?? globalThis.sessionStorage;
  } catch {
    throw new j("Хранилище вкладки недоступно. Разрешите его перед выдачей приглашения; восстановление после перезагрузки иначе невозможно.");
  }
}
function de(n) {
  return `dss.group-invitation-attempt:${n}`;
}
async function Bs(n, a, t) {
  const r = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(a)), i = Array.from(new Uint8Array(r), (s) => s.toString(16).padStart(2, "0")).join(""), o = st(t);
  try {
    const s = o.getItem(de(n));
    if (s) {
      const c = JSON.parse(s);
      if (c && typeof c == "object" && "requestId" in c && "hash" in c && typeof c.requestId == "string" && fr.test(c.requestId) && typeof c.hash == "string") {
        if (c.hash === i) return c.requestId;
        throw new j("Есть незавершённая попытка с другими данными. Повторите прежние поля для восстановления ссылки или сначала проверьте список и явно завершите предыдущую попытку.");
      }
      throw new j("Не удалось восстановить предыдущую попытку. Сначала проверьте список приглашений и явно завершите её.");
    }
    const l = crypto.randomUUID();
    return o.setItem(de(n), JSON.stringify({ requestId: l, hash: i })), l;
  } catch (s) {
    throw s instanceof j ? s : new j("Не удалось сохранить ключ попытки. Разрешите хранилище вкладки; без него нельзя обещать восстановление после перезагрузки.");
  }
}
function Vs(n, a) {
  try {
    st(a).removeItem(de(n));
  } catch {
    throw new j("Не удалось завершить сохранённую попытку. Проверьте список перед новой выдачей.");
  }
}
const S = e.string().uuid(), lt = e.number().int().positive(), Ie = "/portal/distributor-employee-invitations", Se = e.object({
  id: S,
  sourceManagerId: lt,
  sourceManagerExternalId: S,
  sourceManagerName: e.string(),
  role: e.literal("DISTRIBUTOR_EMPLOYEE"),
  email: e.string(),
  name: e.string(),
  expiresAt: e.string().datetime({ offset: !0 }),
  state: e.enum(["PENDING", "ACCEPTED", "REVOKED", "EXPIRED"])
}), Ir = e.object({
  invitation: Se,
  distributorName: e.string().nullable(),
  distributorSubdomain: e.string()
}), Sr = e.object({
  requestId: S,
  sourceManagerId: lt,
  email: e.string().trim().email().max(254),
  name: e.string().trim().min(1).max(200)
});
async function Hs(n, a, t) {
  return e.object({ invitation: Se, token: S }).parse(
    await n.request(Ie, { token: a, method: "POST", body: Sr.parse(t) })
  );
}
async function Fs(n, a) {
  return e.array(Se).parse(await n.request(Ie, { token: a }));
}
async function Ws(n, a, t) {
  await n.request(`${Ie}/${S.parse(t)}`, { token: a, method: "DELETE" });
}
async function Ys(n, a, t) {
  return Ir.parse(await n.request(
    `/invitations/by-token/${S.parse(a)}/employee`,
    { signal: t, cache: "no-store", referrerPolicy: "no-referrer" }
  ));
}
async function Ks(n, a, t, r) {
  const i = e.object({ password: e.string().min(8).max(128), consent: e.literal(!0) }).parse({ password: t, consent: r });
  return e.object({ status: e.enum(["LOGIN_REQUIRED", "LOGIN_EXISTING_ACCOUNT"]) }).parse(
    await n.request(
      `/invitations/by-token/${S.parse(a)}/employee/register`,
      { method: "POST", body: i, cache: "no-store", referrerPolicy: "no-referrer" }
    )
  );
}
async function Qs(n, a, t) {
  return F.parse(await n.request(
    `/invitations/by-token/${S.parse(t)}/employee/accept`,
    {
      token: a,
      method: "POST",
      body: { confirmed: !0 },
      cache: "no-store",
      referrerPolicy: "no-referrer"
    }
  ));
}
function Xs(n, a) {
  const t = new URL("/employee-invite", n);
  if (!["https:", "http:"].includes(t.protocol)) throw new Error("Нужен HTTP(S) адрес портала");
  return t.hash = S.parse(a), t.toString();
}
const m = e.number().int().positive(), Q = e.string().regex(/^-?\d+(\.\d+)?$/), wr = e.enum([
  "permission_missing",
  "policy_disabled",
  "source_snapshot_missing",
  "mutation_pending",
  "source_window_unverified",
  "operation_adapter_not_verified"
]), Le = e.object({ allowed: e.literal(!1), reasons: e.array(wr).min(1).refine((n) => n.includes("source_window_unverified") && n.includes("operation_adapter_not_verified")) }), vr = e.object({
  policyVersion: e.number().int().nonnegative(),
  edit: Le,
  cancel: Le
});
async function Js(n, a, t, r) {
  return m.parse(t), vr.parse(await n.request(
    `/portal/orders/${t}/operation-availability`,
    { token: a, signal: r }
  ));
}
const ct = e.object({
  id: m,
  externalId: e.string().uuid(),
  documentNumber: e.string().nullable(),
  documentDate: e.string().nullable(),
  createdAt: e.string(),
  origin: e.enum(["UNKNOWN", "SOURCE", "PORTAL"]),
  clientId: m.nullable(),
  tradepointId: m.nullable(),
  legalEntityId: m.nullable(),
  statusCode: e.string(),
  sourceStatusName: e.string().nullable().optional().default(null),
  totalAmount: Q,
  currency: e.string(),
  deliveryAddress: e.string().nullable(),
  deliveryDate: e.string().nullable(),
  comment: e.string().nullable(),
  pending: e.boolean(),
  externalRevision: e.number().int().nullable(),
  syncedAt: e.string().nullable(),
  currentTradepointName: e.string().nullable(),
  currentPayerName: e.string().nullable()
}), Pr = e.object({
  order: ct,
  lines: e.array(e.object({
    id: m,
    lineNumber: e.number().int(),
    skuExternalId: e.string().uuid(),
    name: e.string().nullable(),
    article: e.string().nullable(),
    unitCode: e.string().nullable(),
    unitName: e.string().nullable().optional(),
    quantity: Q,
    price: Q,
    lineTotal: Q
  })),
  statusEvents: e.array(e.object({
    id: m,
    statusFrom: e.string().nullable(),
    statusTo: e.string(),
    occurredAt: e.string(),
    actor: e.string().nullable(),
    comment: e.string().nullable()
  })),
  attachments: e.array(e.object({
    id: m,
    fileName: e.string().nullable(),
    contentType: e.string().nullable(),
    sizeBytes: e.number().nonnegative(),
    kind: e.string(),
    sourceRevision: e.number().int(),
    sourceModifiedAt: e.string().nullable(),
    current: e.literal(!0)
  })),
  attachmentsAllowed: e.boolean(),
  sourceConfirmation: e.object({
    connectionId: e.string().uuid(),
    generation: e.number().int().positive(),
    revision: e.string().regex(/^[1-9]\d*$/),
    receivedAt: e.string(),
    sourceModifiedAt: e.string().nullable(),
    snapshotId: m
  }).nullable().optional().default(null)
}), Er = e.object({
  clientEditAllowed: e.boolean(),
  clientCancelAllowed: e.boolean(),
  employeeEditAllowed: e.boolean(),
  employeeCancelAllowed: e.boolean()
}), X = e.object({
  clientHistoryVisible: e.boolean(),
  version: e.number().int().nonnegative(),
  clientEditAllowed: e.boolean().optional(),
  clientCancelAllowed: e.boolean().optional(),
  employeeEditAllowed: e.boolean().optional(),
  employeeCancelAllowed: e.boolean().optional()
}), Tr = e.object({ command: e.object({
  eventId: e.number().int().positive(),
  kind: e.string(),
  state: e.string(),
  outcome: e.enum(["APPLIED", "REJECTED", "CONFLICT"]).nullable(),
  connectionId: e.string().uuid().nullable(),
  generation: e.number().int().positive().nullable(),
  sourceOrderId: e.string().uuid().nullable(),
  resultRevision: e.string().regex(/^[1-9]\d*$/).nullable(),
  errorCode: e.string().nullable(),
  receivedAt: e.string().nullable()
}).nullable() });
async function Zs(n, a, t, r) {
  return Tr.parse(await n.request(
    `/portal/orders/${m.parse(t)}/command-status`,
    { token: a, signal: r }
  ));
}
const Ar = e.object({
  id: e.string().uuid(),
  connectionId: e.string().uuid(),
  sourceOrderId: e.string().uuid(),
  generation: e.number().int().positive(),
  revision: e.string().regex(/^[1-9]\d*$/),
  templateId: e.string(),
  templateVersion: e.string(),
  fileName: e.string(),
  sha256: e.string(),
  sizeBytes: e.number().int().nonnegative(),
  receivedAt: e.string(),
  state: e.literal("CURRENT"),
  replayed: e.literal(!1)
});
async function el(n, a, t, r) {
  return e.array(Ar).parse(await n.request(
    `/portal/orders/${m.parse(t)}/source-assets`,
    { token: a, signal: r }
  ));
}
async function tl(n, a, t, r, i) {
  const o = typeof window > "u" ? "http://localhost" : window.location.origin, s = new URL(`${n.config.baseUrl}/portal/orders/${m.parse(t)}/source-assets/${e.string().uuid().parse(r)}/download`, o), l = await (n.config.fetch ?? fetch)(s.toString(), {
    headers: { Authorization: `Bearer ${a}` },
    cache: "no-store",
    signal: i
  });
  if (!l.ok) throw new $("Не удалось получить текущий PDF заказа", l.status);
  return l.blob();
}
async function nl(n, a, t = {}, r) {
  return e.object({
    content: e.array(ct),
    totalElements: e.number().int().nonnegative(),
    totalPages: e.number().int().nonnegative()
  }).parse(await n.request("/portal/orders", {
    token: a,
    query: { ...t, size: 20 },
    signal: r
  }));
}
async function al(n, a, t, r) {
  return Pr.parse(await n.request(`/portal/orders/${m.parse(t)}`, { token: a, signal: r }));
}
async function rl(n, a) {
  return X.parse(await n.request("/portal/order-policy", { token: a }));
}
async function il(n, a, t) {
  const r = X.parse(t);
  return X.parse(await n.request("/portal/order-policy", {
    token: a,
    method: "PUT",
    body: { expectedVersion: r.version, clientHistoryVisible: r.clientHistoryVisible }
  }));
}
async function ol(n, a, t, r) {
  const i = Er.parse(r);
  return X.parse(await n.request("/portal/order-policy/mutations", {
    token: a,
    method: "PUT",
    body: { expectedVersion: e.number().int().nonnegative().parse(t), ...i }
  }));
}
async function sl(n, a, t, r, i) {
  const o = typeof window > "u" ? "http://localhost" : window.location.origin, s = new URL(`${n.config.baseUrl}/portal/orders/${m.parse(t)}/attachments/${m.parse(r)}`, o), l = await (n.config.fetch ?? fetch)(s.toString(), {
    headers: { Authorization: `Bearer ${a}` },
    cache: "no-store",
    signal: i
  });
  if (!l.ok) throw new $("Не удалось получить текущий файл заказа", l.status);
  return l.blob();
}
const we = e.object({ connectionId: e.string().uuid(), runId: e.string().uuid() }), Me = e.object({
  dataset: e.string().nullable(),
  externalId: e.string().nullable(),
  code: e.string(),
  message: e.string()
}), ut = we.extend({
  contract: e.string(),
  canApply: e.boolean(),
  counts: e.record(e.number().int().nonnegative()),
  blockers: e.array(Me),
  blockerCount: e.number().int().nonnegative(),
  diagnosticsTruncated: e.boolean(),
  warnings: e.array(Me),
  warningCount: e.number().int().nonnegative(),
  appliedAt: e.string().nullable(),
  replayed: e.boolean()
});
async function ll(n, a, t, r) {
  return ut.parse(await n.request("/portal/commercial/preview", {
    token: a,
    method: "POST",
    body: we.parse(t),
    signal: r
  }));
}
async function cl(n, a, t) {
  return ut.parse(await n.request("/portal/commercial/apply", {
    token: a,
    method: "POST",
    body: we.parse(t)
  }));
}
const I = e.string().uuid(), ve = e.object({
  managerId: e.number().int().positive(),
  sourceExternalId: I,
  name: e.string(),
  active: e.boolean(),
  connectionId: I,
  runId: I
}), Or = e.object({
  connectionId: I,
  runId: I,
  managersApplied: e.number().int().nonnegative(),
  clientsResolved: e.number().int().nonnegative(),
  unresolvedCount: e.number().int().nonnegative(),
  blockedEmployees: e.number().int().nonnegative(),
  unresolved: e.array(e.object({
    clientId: e.number().int().positive(),
    clientName: e.string(),
    sourceClientExternalId: I,
    sourceManagerExternalId: I.nullable(),
    reason: e.string()
  }))
});
async function ul(n, a, t) {
  const r = e.object({ connectionId: I, runId: I }).parse(t);
  return Or.parse(await n.request("/portal/source-managers/project", {
    token: a,
    method: "POST",
    body: r
  }));
}
async function dl(n, a, t = "", r = 0) {
  return e.object({
    content: e.array(ve),
    totalPages: e.number().int(),
    totalElements: e.number().int()
  }).parse(await n.request("/portal/source-managers/candidates", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
const D = e.number().int().positive(), re = e.number().int().nonnegative(), Cr = e.object({ code: e.string(), label: e.string() }), x = e.object({
  membership: F.extend({ blockReason: e.string().nullable() }),
  name: e.string().nullable(),
  email: e.string().nullable(),
  sourceManager: ve.nullable(),
  overrides: e.array(e.object({ code: e.string(), effect: e.enum(["GRANT", "DENY"]) })),
  effectivePermissions: e.array(e.string()),
  sessionRevocationPending: e.boolean()
});
async function ml(n, a, t = 0) {
  return e.object({
    content: e.array(x),
    totalPages: e.number().int(),
    totalElements: e.number().int()
  }).parse(await n.request("/portal/employees", {
    token: a,
    query: { page: t, size: 20 }
  }));
}
async function bl(n, a, t) {
  return x.parse(await n.request(`/portal/employees/${D.parse(t)}`, { token: a }));
}
async function pl(n, a) {
  return e.array(Cr).parse(await n.request("/portal/employees/permission-catalog", { token: a }));
}
async function gl(n, a, t = "", r = 0) {
  return e.object({
    content: e.array(ve),
    totalPages: e.number().int(),
    totalElements: e.number().int()
  }).parse(await n.request("/portal/employees/source-managers", {
    token: a,
    query: { search: t, page: r, size: 20 }
  }));
}
async function yl(n, a, t, r) {
  return x.parse(await n.request(`/portal/employees/${D.parse(t)}/block`, {
    token: a,
    method: "POST",
    body: { expectedVersion: re.parse(r) }
  }));
}
async function hl(n, a, t, r) {
  return x.parse(await n.request(`/portal/employees/${D.parse(t)}/restore`, {
    token: a,
    method: "POST",
    body: { expectedVersion: re.parse(r), confirmed: !0 }
  }));
}
async function fl(n, a, t, r, i) {
  return x.parse(await n.request(`/portal/employees/${D.parse(t)}/source-manager`, {
    token: a,
    method: "PUT",
    body: { expectedVersion: re.parse(r), sourceManagerId: D.parse(i) }
  }));
}
async function Il(n, a, t, r, i, o) {
  return x.parse(await n.request(`/portal/employees/${D.parse(t)}/permissions/${encodeURIComponent(i)}`, {
    token: a,
    method: "PUT",
    body: {
      expectedVersion: re.parse(r),
      effect: e.enum(["GRANT", "DENY", "INHERIT"]).parse(o)
    }
  }));
}
const Rr = e.object({
  membershipId: e.number().int().positive(),
  distributorId: e.number().int().positive(),
  role: e.enum(["DISTRIBUTOR_OWNER", "DISTRIBUTOR_EMPLOYEE", "CLIENT_OWNER", "CLIENT_EMPLOYEE"]),
  state: e.literal("ACTIVE"),
  clientGroupId: e.number().int().positive().nullable(),
  clientGroupName: e.string().nullable(),
  sourceManagerId: e.number().int().positive().nullable(),
  permissions: e.array(e.string()),
  version: e.number().int().nonnegative()
});
async function Sl(n, a) {
  return Rr.parse(await n.request("/portal/session", { token: a }));
}
const f = e.number().int().positive(), dt = e.object({
  id: f,
  externalId: e.string().uuid().nullable(),
  name: e.string(),
  pending: e.boolean(),
  active: e.boolean()
}), mt = dt.extend({ clientId: f, address: e.string().nullable() }), bt = e.object({
  id: f,
  clientId: f,
  name: e.string(),
  inn: e.string().nullable(),
  active: e.boolean()
}), jr = bt.extend({ externalId: e.string().uuid().nullable(), kpp: e.string().nullable() }), pt = e.object({
  tradepoint: mt,
  groupId: f,
  groupName: e.string(),
  groupVersion: e.number().int().min(-1),
  allowedPayers: e.array(bt.extend({ pending: e.boolean() }))
}), Pe = (n) => e.object({
  content: e.array(n),
  totalPages: e.number().int().nonnegative(),
  totalElements: e.number().int().nonnegative()
});
async function wl(n, a, t, r) {
  return Pe(dt).parse(await n.request("/portal/manager/clients", { token: a, query: { search: t, page: r, size: 20 } }));
}
async function vl(n, a, t, r, i) {
  return f.parse(t), Pe(mt).parse(await n.request(`/portal/manager/clients/${t}/tradepoints`, { token: a, query: { search: r, page: i, size: 20 } }));
}
async function Pl(n, a, t) {
  return f.parse(t), pt.parse(await n.request(`/portal/manager/tradepoints/${t}/payers`, { token: a }));
}
async function El(n, a, t, r, i) {
  return f.parse(t), Pe(jr).parse(await n.request(`/portal/manager/tradepoints/${t}/payers/candidates`, { token: a, query: { search: r, page: i, size: 20 } }));
}
async function Tl(n, a, t, r, i) {
  f.parse(t);
  const o = e.object({ expectedGroupVersion: e.number().int().min(-1), payerIds: e.array(f).max(500).refine((s) => new Set(s).size === s.length) }).parse({ expectedGroupVersion: r, payerIds: i });
  return pt.parse(await n.request(`/portal/manager/tradepoints/${t}/payers`, { token: a, method: "PUT", body: o }));
}
const y = e.number().int().positive().safe(), ue = e.string().regex(/^-?\d+(\.\d+)?$/), qr = e.object({
  skuId: y,
  sourceId: e.string(),
  productId: y,
  productName: e.string(),
  description: e.string().nullable(),
  slug: e.string(),
  categoryId: y.nullable(),
  name: e.string(),
  article: e.string().nullable(),
  unitCode: e.string().nullable(),
  unitName: e.string().nullable().optional(),
  unitRatio: ue.nullable(),
  price: ue.nullable(),
  currency: e.string().nullable(),
  availableQuantity: ue.nullable(),
  stockReceivedAt: e.string().nullable(),
  stockCaptureStartedAt: e.string().datetime({ offset: !0 }).nullable().optional().default(null),
  availabilityReasons: e.array(e.object({ code: e.string(), message: e.string() })),
  canAddToCart: e.boolean()
}), gt = (n) => e.object({
  content: e.array(n),
  totalElements: e.number().int().nonnegative(),
  totalPages: e.number().int().nonnegative(),
  number: e.number().int().nonnegative(),
  size: e.number().int().positive()
}), yt = e.object({
  tradepointId: y,
  warehouseId: y.nullable(),
  warehouseName: e.string().nullable(),
  items: gt(qr)
}), ht = e.object({ id: y, parentId: y.nullable(), name: e.string() }), Dr = gt(ht), $r = e.array(ht).min(1).max(32);
async function Al(n, a, t, r) {
  return y.parse(t.tradepointId), yt.parse(await n.request("/portal/catalog", { token: a, query: { ...t }, signal: r }));
}
async function Ol(n, a, t, r, i) {
  return y.parse(r.tradepointId), yt.parse(await n.request(
    `/portal/catalog/products/${y.parse(t)}`,
    { token: a, query: r, signal: i }
  ));
}
async function Cl(n, a, t = {}, r) {
  return Dr.parse(await n.request("/portal/catalog/categories", { token: a, query: t, signal: r }));
}
async function Rl(n, a, t, r) {
  return $r.parse(await n.request(
    `/portal/catalog/categories/${y.parse(t)}/path`,
    { token: a, signal: r }
  ));
}
const A = e.number().int().positive().safe(), ie = e.number().int().nonnegative().safe(), J = e.object({ tradepointId: A, payerId: A }), N = e.object({
  membership: F.extend({ blockReason: e.string().nullable() }),
  name: e.string().nullable(),
  email: e.string().nullable(),
  assignedPairs: e.array(J),
  effectivePairs: e.array(J),
  overrides: e.array(e.object({ code: e.string(), effect: e.enum(["GRANT", "DENY"]) })),
  effectivePermissions: e.array(e.string()),
  sessionRevocationPending: e.boolean()
}), xr = e.object({
  groupVersion: e.number().int().min(-1).safe(),
  pairs: e.array(J.extend({
    tradepointName: e.string(),
    address: e.string().nullable(),
    payerName: e.string(),
    inn: e.string().nullable()
  }))
}), Nr = e.object({
  code: e.string(),
  label: e.string(),
  canGrant: e.boolean()
});
async function jl(n, a, t = 0, r) {
  return e.object({
    content: e.array(N),
    totalElements: e.number().int().nonnegative(),
    totalPages: e.number().int().nonnegative()
  }).parse(await n.request(
    "/portal/client-employees",
    { token: a, query: { page: t, size: 20 }, signal: r }
  ));
}
async function ql(n, a, t, r) {
  return N.parse(await n.request(`/portal/client-employees/${A.parse(t)}`, { token: a, signal: r }));
}
async function Dl(n, a, t) {
  return xr.parse(await n.request("/portal/client-employees/pair-candidates", { token: a, signal: t }));
}
async function $l(n, a, t) {
  return e.array(Nr).parse(await n.request("/portal/client-employees/permission-catalog", { token: a, signal: t }));
}
async function xl(n, a, t, r) {
  return N.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/block`,
    { token: a, method: "POST", body: { expectedVersion: ie.parse(r) } }
  ));
}
async function Nl(n, a, t, r) {
  return N.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/restore`,
    { token: a, method: "POST", body: { expectedVersion: ie.parse(r), confirmed: !0 } }
  ));
}
async function kl(n, a, t, r, i, o) {
  return N.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/pairs`,
    { token: a, method: "PUT", body: {
      expectedVersion: ie.parse(r),
      expectedGroupVersion: e.number().int().min(-1).safe().parse(i),
      pairs: e.array(J).max(500).parse(o)
    } }
  ));
}
async function Ul(n, a, t, r, i, o) {
  return N.parse(await n.request(
    `/portal/client-employees/${A.parse(t)}/permissions/${encodeURIComponent(i)}`,
    { token: a, method: "PUT", body: {
      expectedVersion: ie.parse(r),
      effect: e.enum(["GRANT", "DENY", "INHERIT"]).parse(o)
    } }
  ));
}
const b = e.number().int().positive().safe(), k = e.number().int().nonnegative().safe(), Ee = e.object({
  id: b,
  name: e.string(),
  slug: e.string().nullable(),
  published: e.boolean(),
  archived: e.boolean(),
  publicationVersion: k
}), Te = e.object({
  id: b,
  clientId: b,
  name: e.string(),
  address: e.string().nullable(),
  active: e.boolean(),
  warehouseId: b.nullable(),
  warehouseName: e.string().nullable(),
  warehouseActive: e.boolean().nullable(),
  bindingVersion: k
}), kr = e.object({
  id: b,
  sourceExternalId: e.string().uuid(),
  name: e.string(),
  active: e.boolean(),
  sourceConnectionId: e.string().uuid().nullable(),
  sourceRunId: e.string().uuid().nullable()
}), oe = (n) => e.object({
  content: e.array(n),
  totalPages: e.number().int().nonnegative(),
  totalElements: e.number().int().nonnegative()
}), Ur = e.object({
  skuId: b,
  name: e.string(),
  article: e.string().nullable(),
  unitCode: e.string().nullable(),
  unitName: e.string().nullable(),
  price: e.string().regex(/^-?\d+(\.\d+)?$(?![\s\S])/).nullable(),
  currency: e.string().nullable(),
  availableQuantity: e.string().regex(/^-?\d+(\.\d+)?$(?![\s\S])/).nullable(),
  stockReceivedAt: e.string().nullable(),
  stockCaptureStartedAt: e.string().nullable(),
  reasons: e.array(e.object({ code: e.string(), message: e.string() }))
}), Lr = e.object({
  tradepointId: b,
  warehouseId: b.nullable(),
  warehouseName: e.string().nullable(),
  items: oe(Ur)
});
async function Ll(n, a, t, r, i, o) {
  return Lr.parse(await n.request(
    `/portal/owner/catalog/products/${b.parse(t)}/availability`,
    { token: a, signal: o, query: {
      tradepointId: b.parse(r),
      page: k.parse(i),
      size: 20
    } }
  ));
}
const Ae = (n, a) => ({
  q: e.string().max(160).parse(n),
  page: k.parse(a),
  size: 20
});
async function Ml(n, a, t, r) {
  return oe(Ee).parse(await n.request("/portal/owner/catalog/products", { token: a, query: Ae(t, r) }));
}
async function _l(n, a, t) {
  return Ee.parse(await n.request(`/portal/owner/catalog/products/${b.parse(t)}`, { token: a }));
}
async function zl(n, a, t, r, i) {
  return Ee.parse(await n.request(
    `/portal/owner/catalog/products/${b.parse(t)}/publication`,
    { token: a, method: "PUT", body: { expectedVersion: k.parse(r), published: e.boolean().parse(i) } }
  ));
}
async function Gl(n, a, t, r, i) {
  return oe(Te).parse(await n.request("/portal/owner/tradepoints", { token: a, signal: i, query: Ae(t, r) }));
}
async function Bl(n, a, t) {
  return Te.parse(await n.request(`/portal/owner/tradepoints/${b.parse(t)}`, { token: a }));
}
async function Vl(n, a, t, r) {
  return oe(kr).parse(await n.request("/portal/owner/warehouses", { token: a, query: Ae(t, r) }));
}
async function Hl(n, a, t, r, i) {
  return Te.parse(await n.request(
    `/portal/owner/tradepoints/${b.parse(t)}/warehouse`,
    { token: a, method: "PUT", body: { expectedVersion: k.parse(r), warehouseId: b.nullable().parse(i) } }
  ));
}
const U = e.string().uuid(), Oe = "/portal/distributor-owner-invitations", ft = e.object({ equalRightsAndFullVisibilityConfirmed: e.literal(!0) }).strict(), Ce = e.object({
  id: U,
  email: e.string(),
  name: e.string(),
  role: e.literal("DISTRIBUTOR_OWNER"),
  accessScope: e.literal("ALL_DISTRIBUTOR"),
  disclosureVersion: e.literal("owner-equal-access/v1"),
  permissions: e.array(e.string()),
  state: e.enum(["PENDING", "ACCEPTED", "REVOKED", "EXPIRED"]),
  expiresAt: e.string().datetime({ offset: !0 }),
  acceptedAt: e.string().datetime({ offset: !0 }).nullable()
}), Mr = e.object({
  invitation: Ce,
  distributorName: e.string().nullable(),
  distributorSubdomain: e.string()
}), _r = ft.extend({
  requestId: U,
  email: e.string().trim().email().max(254),
  name: e.string().trim().min(1).max(200)
}).strict(), zr = F.extend({
  role: e.literal("DISTRIBUTOR_OWNER"),
  clientGroupId: e.null(),
  sourceManagerId: e.null()
});
async function Fl(n, a, t) {
  return e.object({ invitation: Ce, token: U }).parse(
    await n.request(Oe, {
      token: a,
      method: "POST",
      body: _r.parse(t),
      cache: "no-store"
    })
  );
}
async function Wl(n, a, t) {
  return e.array(Ce).parse(await n.request(
    Oe,
    { token: a, signal: t, cache: "no-store" }
  ));
}
async function Yl(n, a, t) {
  await n.request(`${Oe}/${U.parse(t)}`, { token: a, method: "DELETE", cache: "no-store" });
}
async function Kl(n, a, t) {
  return Mr.parse(await n.request(
    Re(a),
    { signal: t, cache: "no-store", referrerPolicy: "no-referrer" }
  ));
}
async function Ql(n, a, t, r) {
  const i = e.object({ password: e.string().min(8).max(128), consent: e.literal(!0) }).parse({ password: t, consent: r });
  return e.object({ status: e.enum(["LOGIN_REQUIRED", "LOGIN_EXISTING_ACCOUNT"]) }).parse(
    await n.request(
      `${Re(a)}/register`,
      { method: "POST", body: i, cache: "no-store", referrerPolicy: "no-referrer" }
    )
  );
}
async function Xl(n, a, t, r) {
  const i = ft.parse({ equalRightsAndFullVisibilityConfirmed: r });
  return zr.parse(await n.request(
    `${Re(t)}/accept`,
    { token: a, method: "POST", body: i, cache: "no-store", referrerPolicy: "no-referrer" }
  ));
}
function Jl(n, a) {
  const t = new URL("/owner-invite", n);
  if (!["https:", "http:"].includes(t.protocol)) throw new Error("Нужен HTTP(S) адрес портала");
  return t.hash = U.parse(a), t.toString();
}
function Re(n) {
  return `/invitations/by-token/${U.parse(n)}/owner`;
}
const se = e.object({ connectionId: e.string().uuid(), runId: e.string().uuid() }), It = e.object({
  registered: e.boolean(),
  connectionId: e.string().uuid().nullable(),
  generation: e.number().int().positive().nullable(),
  registeredAt: e.string().datetime({ offset: !0 }).nullable()
}), P = e.number().int().nonnegative().safe(), St = se.extend({
  processed: P,
  applied: P,
  replayed: P,
  stale: P,
  quarantined: P,
  issues: e.object({ content: e.array(e.object({
    sourceObjectId: e.number().int().positive().safe(),
    sourceOrderId: e.string().uuid().nullable(),
    status: e.literal("QUARANTINED"),
    reason: e.string()
  })), totalElements: P, totalPages: P })
});
async function Zl(n, a, t) {
  return It.parse(await n.request("/portal/order-history/registration", { token: a, signal: t }));
}
async function ec(n, a, t) {
  return It.parse(await n.request(
    "/portal/order-history/registration",
    { token: a, method: "POST", body: se.parse(t) }
  ));
}
async function tc(n, a, t) {
  return St.parse(await n.request(
    "/portal/order-history/project",
    { token: a, method: "POST", body: se.parse(t) }
  ));
}
async function nc(n, a, t, r = 0, i) {
  return St.parse(await n.request(
    "/portal/order-history/report",
    { token: a, query: { ...se.parse(t), page: r, size: 20 }, signal: i }
  ));
}
const E = e.string().uuid(), _ = e.string().datetime({ offset: !0 }).nullable(), Gr = e.object({
  connectionId: E,
  runId: E,
  state: e.string(),
  reason: e.string().nullable(),
  createdAt: _,
  completedAt: _,
  captureStartedAt: _,
  automaticModeEnabled: e.boolean(),
  automaticModeConnectionId: E.nullable(),
  automaticModeActivatedAt: _,
  lastAppliedConnectionId: E.nullable(),
  lastAppliedRunId: E.nullable(),
  lastAppliedAt: _,
  historyState: e.string().nullable().optional().default(null),
  historyProcessed: e.number().int().nonnegative().safe().nullable().optional().default(null),
  historyQuarantined: e.number().int().nonnegative().safe().nullable().optional().default(null)
});
async function ac(n, a, t, r) {
  const i = E.parse(t.connectionId), o = E.parse(t.runId);
  return Gr.parse(await n.request(
    `/portal/source-runs/${i}/${o}/projection`,
    { token: a, signal: r }
  ));
}
const z = e.number().int().positive().safe(), G = e.string().uuid(), wt = e.enum(["PENDING", "ACTIVE", "BLOCKED"]), Br = e.object({
  distributorId: z,
  primaryOwner: e.object({ subject: G, name: e.string().nullable(), email: e.string().nullable() }).nullable(),
  membership: e.object({ id: z, role: e.string(), state: wt }).nullable(),
  canProvision: e.boolean(),
  reason: e.string().nullable()
}), Vr = e.object({
  requestId: G,
  ownerSubject: G,
  equalRightsAndFullVisibilityConfirmed: e.literal(!0)
}).strict(), Hr = e.object({
  distributorId: z,
  subject: G,
  membershipId: z,
  role: e.literal("DISTRIBUTOR_OWNER"),
  state: wt,
  requestId: G,
  grantedAt: e.string().datetime({ offset: !0 }),
  replayed: e.boolean()
}), vt = (n) => `/admin/platform/distributors/${z.parse(n)}/owner-access`;
async function rc(n, a, t, r) {
  return Br.parse(await n.request(vt(t), { token: a, signal: r, cache: "no-store" }));
}
async function ic(n, a, t, r) {
  return Hr.parse(await n.request(vt(t), {
    token: a,
    method: "POST",
    body: Vr.parse(r),
    cache: "no-store"
  }));
}
const je = ae.extend({
  canConfirm: e.boolean(),
  rows: e.array(e.object({
    kind: e.enum(["CLIENT", "TRADEPOINT", "PAYER"]),
    sourceExternalId: e.string().uuid(),
    sourceName: e.string(),
    action: e.enum(["CREATE", "REUSE", "BLOCKED"]),
    existingId: e.number().int().positive().nullable(),
    existingName: e.string().nullable(),
    existingClientId: e.number().int().positive().nullable(),
    reason: e.string().nullable(),
    sourceAddress: e.string().nullable().optional().default(null),
    existingAddress: e.string().nullable().optional().default(null),
    sourceInn: e.string().nullable().optional().default(null),
    existingInn: e.string().nullable().optional().default(null),
    sourceKpp: e.string().nullable().optional().default(null),
    existingKpp: e.string().nullable().optional().default(null),
    sourceFields: e.array(e.string()).optional().default([])
  }))
}), qe = "/portal/mapping/reconciliations";
async function oc(n, a, t) {
  return je.parse(await n.request(qe, { token: a, method: "POST", body: t }));
}
async function sc(n, a, t) {
  return je.parse(await n.request(`${qe}/${e.string().uuid().parse(t)}`, { token: a }));
}
async function lc(n, a, t, r) {
  if (!r) throw new Error("Нужно явное согласие на использование существующих записей");
  return je.parse(await n.request(`${qe}/${e.string().uuid().parse(t.id)}/confirm`, {
    token: a,
    method: "POST",
    body: { expectedVersion: t.version, existingRecordsReuseConfirmed: !0 }
  }));
}
const O = e.string().uuid(), Pt = e.object({
  requestId: O,
  connectionId: O,
  generation: e.literal(1),
  adapterId: e.string().min(1),
  artifactSha256: e.string().regex(/^[0-9a-f]{64}$/),
  platformVersion: e.string().min(1),
  configurationVersion: e.string().min(1),
  eventSchema: e.literal("ds2b_event/v1"),
  capabilities: e.array(e.string()),
  runtimeCases: e.record(e.literal("PASS")),
  executedAt: e.string().datetime({ offset: !0 }),
  reportText: e.string().min(100).max(65536).refine(
    (n) => new TextEncoder().encode(n).byteLength <= 65536,
    "Отчёт превышает 64 КиБ UTF-8"
  )
}), De = Pt.omit({ requestId: !0, reportText: !0 }).extend({
  id: O,
  reportSha256: e.string().regex(/^[0-9a-f]{64}$/),
  recordedAt: e.string(),
  recordedBy: O,
  backendContractId: e.string()
}), $e = e.object({
  version: e.number().int().nonnegative(),
  state: e.enum(["UNAPPROVED", "APPROVED", "REVOKED", "INVALIDATED"]),
  evidence: De.nullable(),
  approvedAt: e.string().nullable(),
  approvedBy: O.nullable(),
  revokedReason: e.string().nullable(),
  humanAttested: e.boolean(),
  requiredRuntimeCases: e.array(e.string()),
  requiredCapabilities: e.array(e.string())
}), L = (n) => `/admin/platform/distributors/${e.number().int().positive().parse(n)}/adapter-admissions`;
async function cc(n, a, t) {
  return $e.parse(await n.request(L(t), { token: a }));
}
async function uc(n, a, t) {
  return e.array(De).parse(await n.request(`${L(t)}/evidence`, { token: a }));
}
async function dc(n, a, t, r) {
  return e.string().parse(await n.request(`${L(t)}/evidence/${O.parse(r)}/report`, { token: a }));
}
async function mc(n, a, t, r) {
  return De.parse(await n.request(`${L(t)}/evidence`, {
    token: a,
    method: "POST",
    body: Pt.parse(r)
  }));
}
async function bc(n, a, t, r, i) {
  if (!i.reviewConfirmed) throw new Error("Нужно явно подтвердить проверку отчёта");
  return $e.parse(await n.request(`${L(t)}/${O.parse(r)}/approve`, {
    token: a,
    method: "POST",
    body: i
  }));
}
async function pc(n, a, t, r) {
  return $e.parse(await n.request(`${L(t)}/revoke`, { token: a, method: "POST", body: r }));
}
const q = e.number().int().positive().safe(), Et = e.number().int().nonnegative().safe(), T = e.string().regex(/^-?\d+(?:\.\d+)?$/), Tt = e.object({
  connectionId: e.string().uuid(),
  runId: e.string().uuid(),
  sourceOrderId: e.string().uuid()
}).strict(), _e = e.object({
  documentNumber: e.string().nullable(),
  documentDate: e.string().datetime({ offset: !0 }).nullable(),
  statusCode: e.string(),
  statusName: e.string().nullable(),
  totalAmount: T,
  currency: e.string(),
  deliveryAddress: e.string().nullable(),
  clientId: q.nullable(),
  tradepointId: q.nullable(),
  payerId: q.nullable(),
  clientName: e.string().nullable(),
  tradepointName: e.string().nullable(),
  payerName: e.string().nullable(),
  lineCount: e.number().int().nonnegative().safe()
}), ze = e.object({
  lineNumber: q,
  skuExternalId: e.string().nullable(),
  name: e.string().nullable(),
  quantity: T.nullable(),
  unitCode: e.string().nullable(),
  price: T.nullable(),
  total: T.nullable()
}), xe = Tt.extend({
  id: e.string().uuid(),
  generation: q,
  revision: e.string().regex(/^[1-9]\d*$/),
  version: Et,
  orderId: q.nullable(),
  current: _e.nullable(),
  incoming: _e,
  currentLines: e.array(ze),
  incomingLines: e.array(ze.extend({ quantity: T, price: T, total: T })),
  canConfirm: e.boolean(),
  reason: e.string().nullable(),
  createdAt: e.string().datetime({ offset: !0 }),
  confirmedAt: e.string().datetime({ offset: !0 }).nullable()
}), Ne = "/portal/order-history/adoptions";
async function gc(n, a, t) {
  return xe.parse(await n.request(Ne, { token: a, method: "POST", body: Tt.parse(t) }));
}
async function yc(n, a, t, r) {
  return xe.parse(await n.request(`${Ne}/${e.string().uuid().parse(t)}`, { token: a, signal: r }));
}
async function hc(n, a, t, r) {
  if (!r) throw new Error("Подтвердите применение снимка к существующему заказу");
  return xe.parse(await n.request(`${Ne}/${e.string().uuid().parse(t.id)}/confirm`, {
    token: a,
    method: "POST",
    body: { expectedVersion: Et.parse(t.version), sourceSnapshotAdoptionConfirmed: !0 }
  }));
}
const Fr = e.object({
  displayName: e.string().nullable(),
  phone: e.string().nullable(),
  email: e.string().nullable(),
  officeAddress: e.string().nullable()
}).strict();
async function fc(n, a, t) {
  return Fr.parse(await n.request("/portal/distributor-contacts", { token: a, signal: t }));
}
export {
  _t as AcceptInvitationRequestSchema,
  Jn as ActivityItemSchema,
  Xn as ActivityKindSchema,
  $e as AdapterAdmissionSchema,
  Pt as AdapterEvidenceInputSchema,
  De as AdapterEvidenceSchema,
  Zr as AddToCartRequestSchema,
  sn as AddTradepointsRequestSchema,
  Je as AdminClientListItemSchema,
  fa as AdminClientPageSchema,
  Mn as AdminExchangeTestOrderRequestSchema,
  _n as AdminExchangeTestOrderResponseSchema,
  $ as ApiError,
  Oa as ApplyPhotosResultSchema,
  Gt as AssignWarehouseRequestSchema,
  Gn as BulkOrderActionRequestSchema,
  Vn as BulkOrderActionResponseSchema,
  zn as BulkOrderActionSchema,
  Bn as BulkOrderFailureSchema,
  da as CartLineDetailSchema,
  Jr as CartSnapshotSchema,
  et as CatalogPhotoResponseSchema,
  Ta as CatalogProductAdminListItemSchema,
  Aa as CatalogProductAdminPageSchema,
  Ke as CategoryNodeSchema,
  $t as ChangeEmailRequestSchema,
  xt as ChangePasswordRequestSchema,
  ka as CheckSlugResponseSchema,
  Wn as ClientAgreementListItemSchema,
  aa as ClientContactPatchSchema,
  ea as ClientContactsPatchSchema,
  xr as ClientEmployeePairCandidatesSchema,
  Nr as ClientEmployeePermissionSchema,
  N as ClientEmployeeSchema,
  rt as ClientGroupSchema,
  ln as ClientLookupItemSchema,
  zt as ClientTradepointItemSchema,
  ut as CommercialPreviewSchema,
  La as CreateDistributorRequestSchema,
  _a as CreateDistributorResponseSchema,
  Ut as CreateInvitationRequestSchema,
  Lt as CreateInvitationResponseSchema,
  rn as CreateTerritoryRequestSchema,
  Zn as DashboardActivitySchema,
  Qn as DashboardSummarySchema,
  er as DistributorAuditEventPageSchema,
  at as DistributorAuditEventSchema,
  Ka as DistributorClientHitSchema,
  Fr as DistributorContactsSchema,
  ge as DistributorDetailSchema,
  Da as DistributorListItemSchema,
  $a as DistributorListPageSchema,
  Yn as DistributorManagerListItemSchema,
  Ya as DistributorOrderHitSchema,
  Na as DistributorOwnerSchema,
  Zt as DistributorPriceTypeOptionSchema,
  Qt as DistributorPublicInfoSchema,
  me as DistributorRoleSchema,
  Ja as DistributorSearchResponseSchema,
  B as DistributorSettingsSchema,
  Jt as DistributorSettingsUpdateSchema,
  Xa as DistributorSkuHitSchema,
  H as DistributorStatusSchema,
  Qa as DistributorTradepointHitSchema,
  V as DistributorUserDetailSchema,
  Qe as DistributorUserListItemSchema,
  Hn as DraftAgreementCreateRequestSchema,
  Fn as DraftAgreementDetailSchema,
  Ir as EmployeeInvitationPreviewSchema,
  Se as EmployeeInvitationSchema,
  Cr as EmployeePermissionSchema,
  x as EmployeeSchema,
  Ft as ExchangeCredentialsListItemSchema,
  Wt as ExchangeCredentialsListSchema,
  j as GroupInvitationAttemptError,
  yr as GroupInvitationPreviewSchema,
  fe as GroupInvitationSchema,
  F as GroupMembershipSchema,
  Xt as HexColorSchema,
  It as HistoryRegistrationSchema,
  St as HistoryReportSchema,
  Ht as Integration1cHealthSchema,
  Vt as Integration1cStatusSchema,
  Nt as InvitationDtoSchema,
  ha as InvitationInfoSchema,
  Z as InvitationKindSchema,
  Mt as InvitationPreviewSchema,
  Qr as InvitationRoleSchema,
  He as InvitationStateSchema,
  Xr as InvitationStatusSchema,
  $n as InviteDistributorUserRequestSchema,
  xn as InviteDistributorUserResponseSchema,
  Fe as IssuedExchangeCredentialsSchema,
  na as LegalEntityContactsPatchSchema,
  Or as ManagerProjectionSchema,
  Ea as ManualLinkRequestSchema,
  it as MappedClientSchema,
  ae as MappingPreviewSchema,
  je as MappingReconciliationSchema,
  or as MarkAllReadResponseSchema,
  Sa as MatchCandidateSchema,
  wa as MatchCandidatesPayloadSchema,
  qt as MePatchSchema,
  Dt as MeProfilePatchSchema,
  Ve as MeProfileSchema,
  Be as MeSchema,
  fn as MyAgreementListItemSchema,
  In as MyAgreementPageSchema,
  sa as MyClientContactResponseSchema,
  ra as MyClientResponseSchema,
  Ye as MyContextSchema,
  yn as MyLegalEntityListItemSchema,
  hn as MyLegalEntityPageSchema,
  oa as MyLegalEntityResponseSchema,
  Sn as MyPersonalPriceListItemSchema,
  wn as MyPersonalPricePageSchema,
  pn as MyTradePointListItemSchema,
  gn as MyTradePointPageSchema,
  ia as MyTradePointResponseSchema,
  ar as NotificationItemSchema,
  nr as NotificationKindSchema,
  rr as NotificationPageSchema,
  xa as OnboardingChecklistSchema,
  Kn as OnboardingProgressSchema,
  ca as OnboardingStateSchema,
  la as OnboardingStepSchema,
  xe as OrderAdoptionSchema,
  Tt as OrderAdoptionSelectionSchema,
  Rn as OrderAttachmentInfoSchema,
  Ln as OrderCancelRequestSchema,
  Tr as OrderCommandStatusSchema,
  te as OrderDetailSchema,
  jn as OrderEditEventDetailSchema,
  kn as OrderEditLineRequestSchema,
  Un as OrderEditRequestSchema,
  On as OrderLineDetailSchema,
  mn as OrderListItemSchema,
  Er as OrderMutationPolicySchema,
  vr as OrderOperationAvailabilitySchema,
  bn as OrderPageSchema,
  X as OrderPolicySchema,
  Dn as OrderRepeatResultSchema,
  Cn as OrderStatusEventDetailSchema,
  Mr as OwnerInvitationPreviewSchema,
  Ce as OwnerInvitationSchema,
  u as PageSchema,
  va as PendingOrderListItemSchema,
  Pa as PendingOrderPageSchema,
  Ze as PhotoUploadResponseSchema,
  Za as PlatformAuditLogListItemSchema,
  nt as PlatformAuditLogPageSchema,
  tr as PlatformDistributorUserListItemSchema,
  Ha as PlatformSearchDistributorHitSchema,
  Fa as PlatformSearchOrderHitSchema,
  Wa as PlatformSearchResponseSchema,
  ga as PortalAccessSchema,
  pe as PortalCartSnapshotSchema,
  Dr as PortalCatalogCategoriesSchema,
  $r as PortalCatalogCategoryPathSchema,
  qr as PortalCatalogItemSchema,
  yt as PortalCatalogPageSchema,
  Pr as PortalOrderDetailSchema,
  ct as PortalOrderSchema,
  Rr as PortalSessionSchema,
  Br as PrimaryOwnerAccessSchema,
  Hr as PrimaryOwnerReceiptSchema,
  An as ProductCardDetailSchema,
  Tn as ProductCardSkuSchema,
  En as ProductCardStockSchema,
  Vr as ProvisionPrimaryOwnerSchema,
  Ga as ReassignOwnerRequestSchema,
  Ba as ReassignOwnerResponseSchema,
  qn as RepeatSkippedLineSchema,
  za as ResendInviteResponseSchema,
  vn as SkuSearchItemSchema,
  Pn as SkuSearchPageSchema,
  en as SliceSchema,
  ve as SourceManagerCandidateSchema,
  Ar as SourceOrderAssetSchema,
  Gr as SourceProjectionSchema,
  dr as SourceRunPageSchema,
  mr as SourceRunStatusSchema,
  ur as SourceRunSummarySchema,
  Kt as SyncEventDetailSchema,
  Yt as SyncEventListItemSchema,
  We as SyncEventResponseStatusSchema,
  ua as SyncStateSummarySchema,
  an as TerritoryAssignedUserSchema,
  ee as TerritoryDetailSchema,
  tn as TerritoryListItemSchema,
  nn as TerritoryTradepointBriefSchema,
  Ge as ThemePreferenceSchema,
  cn as TradePointAdminListItemSchema,
  un as TradePointBriefSchema,
  ta as TradePointContactsPatchSchema,
  kt as TradepointWarehouseAssignmentSchema,
  ir as UnreadCountResponseSchema,
  ei as UpdateCartLineRequestSchema,
  dn as UpdateContextRequestSchema,
  Nn as UpdateDistributorUserRequestSchema,
  Va as UpdateStatusRequestSchema,
  on as UpdateTerritoryRequestSchema,
  Bt as WarehouseListItemSchema,
  Qs as acceptEmployeeInvitation,
  zs as acceptGroupInvitation,
  ui as acceptInvitation,
  Xl as acceptOwnerInvitation,
  ao as acceptPublicInvitation,
  Di as acknowledgeOrderChange,
  wo as activateDistributorUser,
  Mi as addCartLine,
  Ei as addTerritoryTradepoints,
  Fo as applyCategoryPhotosToProducts,
  cl as applyCommercialSource,
  bc as approveAdapterEvidence,
  es as archiveDistributor,
  Bs as beginGroupInvitationAttempt,
  xl as blockClientEmployee,
  yl as blockEmployee,
  Ao as bulkOrderAction,
  To as cancelAdminOrder,
  oi as changeEmail,
  ai as changePassword,
  Xo as checkSlug,
  Gi as clearCart,
  Ps as completeOnboarding,
  Cs as confirmMappingPreview,
  lc as confirmMappingReconciliation,
  hc as confirmOrderAdoption,
  Hi as confirmPortalQuote,
  Bi as createAdminExchangeTestOrder,
  Kr as createApiClient,
  xs as createClientGroup,
  Jo as createDistributor,
  ls as createDraftAgreement,
  si as createInvitation,
  Os as createMappingPreview,
  oc as createMappingReconciliation,
  gc as createOrderAdoption,
  wi as createTerritory,
  So as deactivateDistributorUser,
  zi as deleteCartLine,
  Ho as deleteCategoryPhoto,
  ts as deleteDistributor,
  Xi as deleteDistributorLogo,
  Bo as deleteProductPhoto,
  Pi as deleteTerritory,
  $i as downloadOrderAttachment,
  sl as downloadPortalOrderFile,
  tl as downloadSourceOrderAsset,
  Xs as employeeInvitationLink,
  go as exportMyPersonalPricesCsv,
  Ri as exportOrdersCsv,
  zo as fetchCatalogPhotoBlobUrl,
  Zi as fetchDistributorLogoBlobUrl,
  Vs as finishGroupInvitationAttempt,
  cc as getAdapterAdmission,
  dc as getAdapterEvidenceReport,
  Do as getAdminClient,
  Li as getCart,
  Lo as getCatalogAdminProducts,
  ki as getCatalogProductDetail,
  _o as getCategoryPhotos,
  ql as getClientEmployee,
  Wi as getDashboardActivity,
  Fi as getDashboardSummary,
  Qo as getDistributor,
  bs as getDistributorAuditEvent,
  fc as getDistributorContacts,
  Yi as getDistributorSettings,
  ho as getDistributorUser,
  bl as getEmployee,
  Ns as getGroupClients,
  Zl as getHistoryRegistration,
  bi as getIntegration1cHealth,
  ci as getInvitationByToken,
  Pl as getManagerPointPayers,
  Rs as getMappingPreview,
  sc as getMappingReconciliation,
  ti as getMe,
  ri as getMeProfile,
  ro as getMyContext,
  ws as getNotificationsUnreadCount,
  vs as getOnboardingState,
  yc as getOrderAdoption,
  Zs as getOrderCommandStatus,
  ji as getOrderDetail,
  nc as getOrderHistoryReport,
  Js as getOrderOperationAvailability,
  rl as getOrderPolicy,
  Ll as getOwnerCatalogAvailability,
  Bl as getOwnerCatalogPoint,
  _l as getOwnerCatalogProduct,
  hs as getPlatformDistributorSettings,
  Ui as getPortalAccess,
  Rl as getPortalCatalogCategoryPath,
  Ol as getPortalCatalogProduct,
  al as getPortalOrder,
  Sl as getPortalSession,
  rc as getPrimaryOwnerAccess,
  Mo as getProductPhotos,
  eo as getPublicDistributorInfo,
  no as getPublicInvitation,
  ac as getSourceProjection,
  qs as getSourceRunStatus,
  fi as getSyncEvent,
  Ts as getSyncStateSummary,
  Si as getTerritory,
  is as globalSearch,
  Gs as groupInvitationLink,
  vo as hardDeleteDistributorUser,
  ll as inspectCommercialSource,
  fo as inviteDistributorUser,
  rs as isValidInn,
  Hs as issueEmployeeInvitation,
  ks as issueGroupInvitation,
  gi as issueMyExchangeCredentials,
  Fl as issueOwnerInvitation,
  ps as issuePlatformExchangeCredentials,
  Uo as linkPendingOrder,
  uc as listAdapterEvidence,
  ss as listAdminAgreements,
  Oo as listAdminClients,
  Oi as listAdminClientsLookup,
  cs as listAdminManagers,
  Ai as listAdminTradepoints,
  No as listAdminWarehouses,
  Ni as listCatalogCategories,
  Dl as listClientEmployeePairs,
  $l as listClientEmployeePermissions,
  jl as listClientEmployees,
  Ds as listClientGroups,
  $o as listClientTradepoints,
  ms as listDistributorAuditEvents,
  ds as listDistributorAuditLog,
  Ji as listDistributorPriceTypes,
  yo as listDistributorUsers,
  Ko as listDistributors,
  Fs as listEmployeeInvitations,
  pl as listEmployeePermissions,
  gl as listEmployeeSourceManagers,
  ml as listEmployees,
  $s as listGroupCandidates,
  Us as listGroupInvitations,
  li as listInvitations,
  wl as listManagerClients,
  El as listManagerPayerCandidates,
  vl as listManagerPoints,
  As as listMappingSources,
  bo as listMyAgreements,
  pi as listMyExchangeCredentials,
  mo as listMyPayers,
  po as listMyPersonalPrices,
  uo as listMyTradepoints,
  fs as listNotifications,
  Ci as listOrders,
  Gl as listOwnerCatalogPoints,
  Ml as listOwnerCatalogProducts,
  Vl as listOwnerCatalogWarehouses,
  Wl as listOwnerInvitations,
  ko as listPendingOrders,
  us as listPlatformAuditLog,
  ys as listPlatformDistributorUsers,
  Al as listPortalCatalog,
  Cl as listPortalCatalogCategories,
  nl as listPortalOrders,
  dl as listSourceManagers,
  el as listSourceOrderAssets,
  js as listSourceRuns,
  hi as listSyncEvents,
  Ii as listTerritories,
  Ss as markAllNotificationsRead,
  Es as markCredentialsDelivered,
  Is as markNotificationRead,
  ba as orderAttachmentDownloadUrl,
  Jl as ownerInvitationLink,
  Po as patchAdminOrder,
  co as patchClientContact,
  oo as patchClientContacts,
  Ki as patchDistributorSettings,
  lo as patchLegalEntityContacts,
  ni as patchMe,
  ii as patchMeProfile,
  io as patchMyContext,
  so as patchTradePointContacts,
  mi as postLogout,
  Vi as preparePortalQuote,
  Ys as previewEmployeeInvitation,
  Ms as previewGroupInvitation,
  Kl as previewOwnerInvitation,
  tc as projectOrderHistory,
  ul as projectSourceManagers,
  ic as provisionPrimaryOwnerAccess,
  to as publicDistributorLogoUrl,
  as as reassignOwner,
  fl as rebindEmployee,
  mc as recordAdapterEvidence,
  Ks as registerEmployeeInvitation,
  _s as registerGroupInvitation,
  ec as registerHistorySource,
  Ql as registerOwnerInvitation,
  Ti as removeTerritoryTradepoint,
  qi as repeatOrder,
  kl as replaceClientEmployeePairs,
  Tl as replaceManagerPointPayers,
  Eo as repriceAdminOrder,
  Zo as resendInvite,
  Co as resetClientOverlay,
  qo as resetContactOverlay,
  jo as resetLegalEntityOverlay,
  Ro as resetTradepointOverlay,
  Nl as restoreClientEmployee,
  hl as restoreEmployee,
  pc as revokeAdapterAdmission,
  Ws as revokeEmployeeInvitation,
  yi as revokeExchangeCredentials,
  Ls as revokeGroupInvitation,
  di as revokeInvitation,
  Yl as revokeOwnerInvitation,
  gs as revokePlatformExchangeCredentials,
  xi as searchCatalogSku,
  os as searchDistributor,
  Ul as setClientEmployeePermission,
  Il as setEmployeePermission,
  ol as setOrderMutationPolicy,
  il as setOrderPolicy,
  Hl as setOwnerPointWarehouse,
  zl as setOwnerProductPublication,
  Wo as setProductPublication,
  Yo as setProductSlug,
  _i as updateCartLine,
  ns as updateDistributorStatus,
  Io as updateDistributorUser,
  vi as updateTerritory,
  xo as updateTradepointWarehouse,
  Vo as uploadCategoryPhoto,
  Qi as uploadDistributorLogo,
  Go as uploadProductPhoto
};
//# sourceMappingURL=index.js.map
